// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { accountingCreateGlCode, accountingCreatePaymentMethod, accountingCreateTermsCode, accountingDeleteGlCode, accountingDeletePaymentMethod, accountingDeleteTermsCode, accountingGetGlCode, accountingGetPaymentMethod, accountingGetTermsCode, accountingListGlCodes, accountingListPaymentMethods, accountingListTermsCodes, accountingUpdateGlCode, accountingUpdatePaymentMethod, accountingUpdateTermsCode, acquireLock, addOrderNote, archiveChatSession, assignArtist, authorizePayment, calculatePrice, calculateShipDate, capturePayment, chargePayment, checkLock, clearCartons, commitDeposits, commitSales, completeArtworkRequest, copyOrder, createAccessGroup, createAckTemplate, createAlert, createArtworkRequest, createChargeItem, createChatSession, createColdFoilPrinter, createCustomer, createCustomerNote, createCustomerType, createDesign, createHpShipMethod, createLayoutSurfaceBinding, createLayoutSurfaceProfile, createLocationCode, createNonShipDate, createOptionValue, createOrder, createOrderDocument, createPaymentProfile, createPriceDetail, createPriceHeader, createPrinter, createProduct, createProductSpec, createReturnRecall, createShipment, createShippingSpecialInstruction, createShipTo, createTextSnippet, createUser, deleteAccessGroup, deleteAckTemplate, deleteAlert, deleteArtworkRequestImage, deleteChargeItem, deleteColdFoilPrinter, deleteCustomer, deleteCustomerType, deleteHpShipMethod, deleteJob, deleteLayoutSurfaceBinding, deleteLayoutSurfaceProfile, deleteLocationCode, deleteNonShipDate, deleteOptionValue, deleteOrderAttachment, deleteOrderDocument, deletePaymentProfile, deletePriceDetail, deletePriceHeader, deletePrinter, deleteProductSpec, deleteShippingSpecialInstruction, deleteShipTo, deleteTextSnippet, deleteUser, downloadArtworkRequestImage, downloadOrderAttachment, executeBatchPost, executeDeposits, exportCustomers, exportDesigns, exportOrders, exportProducts, exportWorldShip, forceUnlock, generateAcknowledgment, generateArtworkRequestForm, generateGoldenrod, generateInvoice, generatePackingList, generateRecallForm, generateReturnForm, getAccessGroup, getApiAiAdminSessions, getApiAiAdminSessionsByIdMessages, getApiAiAdminStats, getApiReportsGenerated, getApiReportsGeneratedByIdDownload, getArtworkRequest, getArtworkRequestsFilterMetadata, getBatchMaterializationStatus, getCanonicalGraph, getChargeItem, getChatSession, getCompanyDefaults, getCustomer, getCustomerArBalance, getCustomerCreditHold, getCustomersFilterMetadata, getDashboardSummary, getDepositReport, getDesign, getEmailLog, getEmailLogDetail, getEmailSetting, getEmailSettings, getFailedJobs, getHostedPaymentPage, getJobDashboard, getJobDetail, getLayoutSurfaceProfile, getMaterializationStatus, getOption, getOptionValue, getOrder, getOrderActivity, getOrderCharts, getOrderLineItems, getOrdersByDivision, getOrdersByManufacturingLocation, getOrdersByMonth, getOrdersByStatus, getOrdersFilterMetadata, getOrderStatusHistory, getPackDetails, getPriceHeader, getPrintJob, getProduct, getProductionBacklog, getProductOrderOptions, getProductsFilterMetadata, getProductSpec, getRecentActivity, getReturnRecall, getRevenueByMonth, getSalesHistory, getSalesRegisterReport, getSalesTaxReport, getShipmentLabel, getShippingRates, getSucceededJobs, getTaxJarConfig, getTaxJarLog, getTextSnippet, getTimeSpentCharts, getTimeSpentSummary, getTopCustomers, getTopSalesReps, getUser, globalSearch, healthCheck, importWorldShip, listAccessGroups, listAckTemplates, listAlerts, listArtists, listArtworkRequestImages, listArtworkRequests, listArtworkStatusCodes, listArtworkStatusHistory, listChangeLog, listChargeItems, listChatMessages, listChatSessions, listColdFoilPrinters, listCustomerArHistory, listCustomerNotes, listCustomers, listCustomerTypes, listDepositReportPayments, listDesignCategories, listDesigns, listDivisions, listHpShipMethods, listInvoiceEligibleOrders, listLayoutSurfaceBindings, listLayoutSurfaceProfiles, listListMasters, listLocationCodes, listLockedRecords, listMenuItems, listNonShipDates, listOptionFamilies, listOptionLinks, listOptions, listOptionValues, listOrderAttachments, listOrderDocuments, listOrderPayments, listOrders, listOrderShipments, listOrderStatuses, listPackQueue, listPaymentProfiles, listPostEligibleOrders, listPriceHeaders, listPrinters, listPrintJobs, listProducts, listProductSpecs, listProductStatusCodes, listProductTypes, listProductUses, listReturnRecallReasonCodes, listReturnRecallStatuses, listSalesRegisterOrders, listSalesReps, listSalesTaxReportEntries, listShipMethods, listShippingDefaults, listShippingMethods, listShippingSpecialInstructions, listShipTo, listTaxInquiry, listTaxJarLog, listTermsCodes, listTextSnippets, listTimeSpent, listUsers, listValuesByList, listWorldShipExportLog, listWorldShipImportLog, login, logout, lookupThreeCxCustomer, type Options, overrideCreditHold, persistChatMessage, ping, postApiReportsGenerated, postCashReceipt, previewDeposits, previewEmailTemplate, previewWorldShipImport, printOrderDocument, publishLayoutSurfaceProfile, quickPrint, recalculateOrderTotals, refresh, refreshToken, refundPayment, reindexSearch, releaseLock, renewLock, resetPassword, retryFailedJob, retryPrintJob, saveCartons, searchCustomers, searchDesigns, searchOrders, searchProducts, selectAckTemplate, sendInvoiceEmailAsync, sendInvoiceEmailSync, sendOrderConfirmationAsync, sendOrderConfirmationSync, sendShippingNotificationAsync, sendShippingNotificationSync, startBatchGoldenrodPrint, startBatchInvoiceTransmission, testColdFoilPrinterConnection, testTaxJarConnection, trackShipment, triggerBatchMaterialization, triggerMaterialization, triggerRecurringJob, updateAccessGroup, updateAckTemplate, updateAlert, updateArtworkRequest, updateArtworkStatus, updateChargeItem, updateChatSessionTitle, updateColdFoilPrinter, updateCompanyDefaults, updateCustomer, updateCustomerType, updateDesign, updateDesignCategory, updateDivision, updateEmailSetting, updateHpShipMethod, updateLayoutSurfaceProfile, updateLocationCode, updateMenuItem, updateNonShipDate, updateOptionValue, updateOrder, updateOrderCharts, updateOrderDocument, updateOrderStatus, updateOrderTotals, updatePriceDetail, updatePriceHeader, updatePrinter, updateProduct, updateProductSpec, updateReturnRecall, updateShippingDefault, updateShippingSpecialInstruction, updateShipTo, updateTextSnippet, updateUser, uploadArtworkRequestImage, uploadOrderAttachment, validateShippingAddress, voidPayment, voidShipment } from '../sdk.gen';
import type { AccountingCreateGlCodeData, AccountingCreateGlCodeError, AccountingCreateGlCodeResponse, AccountingCreatePaymentMethodData, AccountingCreatePaymentMethodError, AccountingCreatePaymentMethodResponse, AccountingCreateTermsCodeData, AccountingCreateTermsCodeError, AccountingCreateTermsCodeResponse, AccountingDeleteGlCodeData, AccountingDeleteGlCodeError, AccountingDeleteGlCodeResponse, AccountingDeletePaymentMethodData, AccountingDeletePaymentMethodError, AccountingDeletePaymentMethodResponse, AccountingDeleteTermsCodeData, AccountingDeleteTermsCodeError, AccountingDeleteTermsCodeResponse, AccountingGetGlCodeData, AccountingGetGlCodeError, AccountingGetGlCodeResponse, AccountingGetPaymentMethodData, AccountingGetPaymentMethodError, AccountingGetPaymentMethodResponse, AccountingGetTermsCodeData, AccountingGetTermsCodeError, AccountingGetTermsCodeResponse, AccountingListGlCodesData, AccountingListGlCodesResponse, AccountingListPaymentMethodsData, AccountingListPaymentMethodsResponse, AccountingListTermsCodesData, AccountingListTermsCodesResponse, AccountingUpdateGlCodeData, AccountingUpdateGlCodeError, AccountingUpdateGlCodeResponse, AccountingUpdatePaymentMethodData, AccountingUpdatePaymentMethodError, AccountingUpdatePaymentMethodResponse, AccountingUpdateTermsCodeData, AccountingUpdateTermsCodeError, AccountingUpdateTermsCodeResponse, AcquireLockData, AcquireLockError, AcquireLockResponse, AddOrderNoteData, AddOrderNoteError, AddOrderNoteResponse, ArchiveChatSessionData, ArchiveChatSessionError, ArchiveChatSessionResponse, AssignArtistData, AssignArtistError, AssignArtistResponse, AuthorizePaymentData, AuthorizePaymentError, AuthorizePaymentResponse, CalculatePriceData, CalculatePriceResponse2, CalculateShipDateData, CalculateShipDateError, CalculateShipDateResponse, CapturePaymentData, CapturePaymentError, CapturePaymentResponse, ChargePaymentData, ChargePaymentError, ChargePaymentResponse, CheckLockData, CheckLockResponse2, ClearCartonsData, ClearCartonsError, ClearCartonsResponse, CommitDepositsData, CommitDepositsError, CommitDepositsResponse2, CommitSalesData, CommitSalesError, CommitSalesResponse2, CompleteArtworkRequestData, CompleteArtworkRequestError, CompleteArtworkRequestResponse, CopyOrderData, CopyOrderError, CopyOrderResponse, CreateAccessGroupData, CreateAccessGroupError, CreateAccessGroupResponse, CreateAckTemplateData, CreateAckTemplateResponse, CreateAlertData, CreateAlertError, CreateAlertResponse, CreateArtworkRequestData, CreateArtworkRequestError, CreateArtworkRequestResponse, CreateChargeItemData, CreateChargeItemError, CreateChargeItemResponse, CreateChatSessionData, CreateChatSessionResponse, CreateColdFoilPrinterData, CreateColdFoilPrinterError, CreateColdFoilPrinterResponse, CreateCustomerData, CreateCustomerError, CreateCustomerNoteData, CreateCustomerNoteError, CreateCustomerNoteResponse, CreateCustomerResponse, CreateCustomerTypeData, CreateCustomerTypeError, CreateCustomerTypeResponse, CreateDesignData, CreateDesignError, CreateDesignResponse, CreateHpShipMethodData, CreateHpShipMethodError, CreateHpShipMethodResponse, CreateLayoutSurfaceBindingData, CreateLayoutSurfaceBindingResponse, CreateLayoutSurfaceProfileData, CreateLayoutSurfaceProfileResponse, CreateLocationCodeData, CreateLocationCodeError, CreateLocationCodeResponse, CreateNonShipDateData, CreateNonShipDateError, CreateNonShipDateResponse, CreateOptionValueData, CreateOptionValueError, CreateOptionValueResponse, CreateOrderData, CreateOrderDocumentData, CreateOrderDocumentError, CreateOrderDocumentResponse, CreateOrderError, CreateOrderResponse, CreatePaymentProfileData, CreatePaymentProfileError, CreatePaymentProfileResponse, CreatePriceDetailData, CreatePriceDetailError, CreatePriceDetailResponse, CreatePriceHeaderData, CreatePriceHeaderError, CreatePriceHeaderResponse, CreatePrinterData, CreatePrinterError, CreatePrinterResponse, CreateProductData, CreateProductError, CreateProductResponse, CreateProductSpecData, CreateProductSpecError, CreateProductSpecResponse, CreateReturnRecallData, CreateReturnRecallError, CreateReturnRecallResponse, CreateShipmentData, CreateShipmentError, CreateShipmentResponse2, CreateShippingSpecialInstructionData, CreateShippingSpecialInstructionError, CreateShippingSpecialInstructionResponse, CreateShipToData, CreateShipToError, CreateShipToResponse, CreateTextSnippetData, CreateTextSnippetError, CreateTextSnippetResponse, CreateUserData, CreateUserError, CreateUserResponse, DeleteAccessGroupData, DeleteAccessGroupError, DeleteAccessGroupResponse, DeleteAckTemplateData, DeleteAckTemplateError, DeleteAckTemplateResponse, DeleteAlertData, DeleteAlertError, DeleteAlertResponse, DeleteArtworkRequestImageData, DeleteArtworkRequestImageError, DeleteArtworkRequestImageResponse, DeleteChargeItemData, DeleteChargeItemError, DeleteChargeItemResponse, DeleteColdFoilPrinterData, DeleteColdFoilPrinterError, DeleteColdFoilPrinterResponse, DeleteCustomerData, DeleteCustomerError, DeleteCustomerResponse, DeleteCustomerTypeData, DeleteCustomerTypeError, DeleteCustomerTypeResponse, DeleteHpShipMethodData, DeleteHpShipMethodError, DeleteHpShipMethodResponse, DeleteJobData, DeleteJobError, DeleteJobResponse, DeleteLayoutSurfaceBindingData, DeleteLayoutSurfaceBindingError, DeleteLayoutSurfaceProfileData, DeleteLayoutSurfaceProfileError, DeleteLocationCodeData, DeleteLocationCodeError, DeleteLocationCodeResponse, DeleteNonShipDateData, DeleteNonShipDateError, DeleteNonShipDateResponse, DeleteOptionValueData, DeleteOptionValueError, DeleteOptionValueResponse, DeleteOrderAttachmentData, DeleteOrderAttachmentError, DeleteOrderAttachmentResponse, DeleteOrderDocumentData, DeleteOrderDocumentError, DeleteOrderDocumentResponse, DeletePaymentProfileData, DeletePaymentProfileError, DeletePaymentProfileResponse, DeletePriceDetailData, DeletePriceDetailError, DeletePriceDetailResponse, DeletePriceHeaderData, DeletePriceHeaderError, DeletePriceHeaderResponse, DeletePrinterData, DeletePrinterError, DeletePrinterResponse, DeleteProductSpecData, DeleteProductSpecError, DeleteProductSpecResponse, DeleteShippingSpecialInstructionData, DeleteShippingSpecialInstructionError, DeleteShippingSpecialInstructionResponse, DeleteShipToData, DeleteShipToError, DeleteShipToResponse, DeleteTextSnippetData, DeleteTextSnippetError, DeleteTextSnippetResponse, DeleteUserData, DeleteUserError, DeleteUserResponse, DownloadArtworkRequestImageData, DownloadArtworkRequestImageError, DownloadOrderAttachmentData, DownloadOrderAttachmentError, ExecuteBatchPostData, ExecuteBatchPostError, ExecuteBatchPostResponse, ExecuteDepositsData, ExecuteDepositsError, ExecuteDepositsResponse, ExportCustomersData, ExportDesignsData, ExportOrdersData, ExportProductsData, ExportWorldShipData, ExportWorldShipError, ExportWorldShipResponse, ForceUnlockData, ForceUnlockResponse, GenerateAcknowledgmentData, GenerateAcknowledgmentError, GenerateArtworkRequestFormData, GenerateArtworkRequestFormError, GenerateGoldenrodData, GenerateGoldenrodError, GenerateInvoiceData, GenerateInvoiceError, GeneratePackingListData, GeneratePackingListError, GenerateRecallFormData, GenerateRecallFormError, GenerateReturnFormData, GenerateReturnFormError, GetAccessGroupData, GetAccessGroupError, GetAccessGroupResponse, GetApiAiAdminSessionsByIdMessagesData, GetApiAiAdminSessionsByIdMessagesError, GetApiAiAdminSessionsByIdMessagesResponse, GetApiAiAdminSessionsData, GetApiAiAdminSessionsResponse, GetApiAiAdminStatsData, GetApiAiAdminStatsError, GetApiAiAdminStatsResponse, GetApiReportsGeneratedByIdDownloadData, GetApiReportsGeneratedData, GetApiReportsGeneratedResponse, GetArtworkRequestData, GetArtworkRequestError, GetArtworkRequestResponse, GetArtworkRequestsFilterMetadataData, GetArtworkRequestsFilterMetadataResponse, GetBatchMaterializationStatusData, GetBatchMaterializationStatusError, GetBatchMaterializationStatusResponse, GetCanonicalGraphData, GetCanonicalGraphError, GetCanonicalGraphResponse, GetChargeItemData, GetChargeItemError, GetChargeItemResponse, GetChatSessionData, GetChatSessionError, GetChatSessionResponse, GetCompanyDefaultsData, GetCompanyDefaultsError, GetCompanyDefaultsResponse, GetCustomerArBalanceData, GetCustomerArBalanceError, GetCustomerArBalanceResponse, GetCustomerCreditHoldData, GetCustomerCreditHoldResponse, GetCustomerData, GetCustomerError, GetCustomerResponse, GetCustomersFilterMetadataData, GetCustomersFilterMetadataResponse, GetDashboardSummaryData, GetDashboardSummaryResponse, GetDepositReportData, GetDesignData, GetDesignError, GetDesignResponse, GetEmailLogData, GetEmailLogDetailData, GetEmailLogDetailError, GetEmailLogDetailResponse, GetEmailLogResponse, GetEmailSettingData, GetEmailSettingError, GetEmailSettingResponse, GetEmailSettingsData, GetEmailSettingsResponse, GetFailedJobsData, GetFailedJobsResponse, GetHostedPaymentPageData, GetHostedPaymentPageError, GetHostedPaymentPageResponse, GetJobDashboardData, GetJobDashboardResponse, GetJobDetailData, GetJobDetailError, GetJobDetailResponse, GetLayoutSurfaceProfileData, GetLayoutSurfaceProfileError, GetLayoutSurfaceProfileResponse, GetMaterializationStatusData, GetMaterializationStatusError, GetMaterializationStatusResponse, GetOptionData, GetOptionError, GetOptionResponse, GetOptionValueData, GetOptionValueError, GetOptionValueResponse, GetOrderActivityData, GetOrderActivityError, GetOrderActivityResponse, GetOrderChartsData, GetOrderChartsError, GetOrderChartsResponse, GetOrderData, GetOrderError, GetOrderLineItemsData, GetOrderLineItemsError, GetOrderLineItemsResponse, GetOrderResponse, GetOrdersByDivisionData, GetOrdersByDivisionResponse, GetOrdersByManufacturingLocationData, GetOrdersByManufacturingLocationResponse, GetOrdersByMonthData, GetOrdersByMonthResponse, GetOrdersByStatusData, GetOrdersByStatusResponse, GetOrdersFilterMetadataData, GetOrdersFilterMetadataResponse, GetOrderStatusHistoryData, GetOrderStatusHistoryResponse, GetPackDetailsData, GetPackDetailsError, GetPackDetailsResponse, GetPriceHeaderData, GetPriceHeaderError, GetPriceHeaderResponse, GetPrintJobData, GetPrintJobError, GetPrintJobResponse, GetProductData, GetProductError, GetProductionBacklogData, GetProductionBacklogResponse, GetProductOrderOptionsData, GetProductOrderOptionsResponse, GetProductResponse, GetProductsFilterMetadataData, GetProductsFilterMetadataResponse, GetProductSpecData, GetProductSpecError, GetProductSpecResponse, GetRecentActivityData, GetRecentActivityResponse, GetReturnRecallData, GetReturnRecallError, GetReturnRecallResponse, GetRevenueByMonthData, GetRevenueByMonthResponse, GetSalesHistoryData, GetSalesHistoryError, GetSalesHistoryResponse, GetSalesRegisterReportData, GetSalesTaxReportData, GetShipmentLabelData, GetShipmentLabelError, GetShipmentLabelResponse, GetShippingRatesData, GetShippingRatesError, GetShippingRatesResponse, GetSucceededJobsData, GetSucceededJobsResponse, GetTaxJarConfigData, GetTaxJarConfigResponse, GetTaxJarLogData, GetTaxJarLogError, GetTaxJarLogResponse, GetTextSnippetData, GetTextSnippetError, GetTextSnippetResponse, GetTimeSpentChartsData, GetTimeSpentChartsResponse, GetTimeSpentSummaryData, GetTimeSpentSummaryResponse, GetTopCustomersData, GetTopCustomersResponse, GetTopSalesRepsData, GetTopSalesRepsResponse, GetUserData, GetUserError, GetUserResponse, GlobalSearchData, GlobalSearchResponse2, HealthCheckData, HealthCheckResponse2, ImportWorldShipData, ImportWorldShipError, ImportWorldShipResponse, ListAccessGroupsData, ListAccessGroupsResponse, ListAckTemplatesData, ListAckTemplatesResponse, ListAlertsData, ListAlertsResponse, ListArtistsData, ListArtistsResponse, ListArtworkRequestImagesData, ListArtworkRequestImagesError, ListArtworkRequestImagesResponse, ListArtworkRequestsData, ListArtworkRequestsResponse, ListArtworkStatusCodesData, ListArtworkStatusCodesResponse, ListArtworkStatusHistoryData, ListArtworkStatusHistoryError, ListArtworkStatusHistoryResponse, ListChangeLogData, ListChangeLogResponse, ListChargeItemsData, ListChargeItemsResponse, ListChatMessagesData, ListChatMessagesResponse, ListChatSessionsData, ListChatSessionsResponse, ListColdFoilPrintersData, ListColdFoilPrintersResponse, ListCustomerArHistoryData, ListCustomerArHistoryResponse, ListCustomerNotesData, ListCustomerNotesResponse, ListCustomersData, ListCustomersResponse, ListCustomerTypesData, ListCustomerTypesResponse, ListDepositReportPaymentsData, ListDepositReportPaymentsResponse, ListDesignCategoriesData, ListDesignCategoriesResponse, ListDesignsData, ListDesignsResponse, ListDivisionsData, ListDivisionsResponse, ListHpShipMethodsData, ListHpShipMethodsResponse, ListInvoiceEligibleOrdersData, ListInvoiceEligibleOrdersResponse, ListLayoutSurfaceBindingsData, ListLayoutSurfaceBindingsResponse, ListLayoutSurfaceProfilesData, ListLayoutSurfaceProfilesResponse, ListListMastersData, ListListMastersResponse, ListLocationCodesData, ListLocationCodesResponse, ListLockedRecordsData, ListLockedRecordsResponse, ListMenuItemsData, ListMenuItemsResponse, ListNonShipDatesData, ListNonShipDatesResponse, ListOptionFamiliesData, ListOptionFamiliesResponse, ListOptionLinksData, ListOptionLinksResponse, ListOptionsData, ListOptionsResponse, ListOptionValuesData, ListOptionValuesResponse, ListOrderAttachmentsData, ListOrderAttachmentsResponse, ListOrderDocumentsData, ListOrderDocumentsResponse, ListOrderPaymentsData, ListOrderPaymentsError, ListOrderPaymentsResponse, ListOrdersData, ListOrderShipmentsData, ListOrderShipmentsError, ListOrderShipmentsResponse, ListOrdersResponse, ListOrderStatusesData, ListOrderStatusesResponse, ListPackQueueData, ListPackQueueResponse, ListPaymentProfilesData, ListPaymentProfilesError, ListPaymentProfilesResponse, ListPostEligibleOrdersData, ListPostEligibleOrdersResponse, ListPriceHeadersData, ListPriceHeadersResponse, ListPrintersData, ListPrintersResponse, ListPrintJobsData, ListPrintJobsResponse, ListProductsData, ListProductSpecsData, ListProductSpecsResponse, ListProductsResponse, ListProductStatusCodesData, ListProductStatusCodesResponse, ListProductTypesData, ListProductTypesResponse, ListProductUsesData, ListProductUsesResponse, ListReturnRecallReasonCodesData, ListReturnRecallReasonCodesResponse, ListReturnRecallStatusesData, ListReturnRecallStatusesResponse, ListSalesRegisterOrdersData, ListSalesRegisterOrdersResponse, ListSalesRepsData, ListSalesRepsResponse, ListSalesTaxReportEntriesData, ListSalesTaxReportEntriesResponse, ListShipMethodsData, ListShipMethodsResponse, ListShippingDefaultsData, ListShippingDefaultsResponse, ListShippingMethodsData, ListShippingMethodsResponse, ListShippingSpecialInstructionsData, ListShippingSpecialInstructionsResponse, ListShipToData, ListShipToResponse, ListTaxInquiryData, ListTaxInquiryResponse, ListTaxJarLogData, ListTaxJarLogResponse, ListTermsCodesData, ListTermsCodesResponse, ListTextSnippetsData, ListTextSnippetsResponse, ListTimeSpentData, ListTimeSpentResponse, ListUsersData, ListUsersResponse, ListValuesByListData, ListValuesByListResponse, ListWorldShipExportLogData, ListWorldShipExportLogResponse, ListWorldShipImportLogData, ListWorldShipImportLogResponse, LoginData, LoginResponse2, LogoutData, LogoutResponse, LookupThreeCxCustomerData, LookupThreeCxCustomerError, LookupThreeCxCustomerResponse, OverrideCreditHoldData, OverrideCreditHoldError, OverrideCreditHoldResponse, PersistChatMessageData, PersistChatMessageError, PersistChatMessageResponse, PingData, PingResponse2, PostApiReportsGeneratedData, PostApiReportsGeneratedResponse, PostCashReceiptData, PostCashReceiptError, PostCashReceiptResponse, PreviewDepositsData, PreviewDepositsResponse, PreviewEmailTemplateData, PreviewEmailTemplateError, PreviewEmailTemplateResponse, PreviewWorldShipImportData, PreviewWorldShipImportError, PreviewWorldShipImportResponse, PrintOrderDocumentData, PrintOrderDocumentError, PrintOrderDocumentResponse, PublishLayoutSurfaceProfileData, PublishLayoutSurfaceProfileError, PublishLayoutSurfaceProfileResponse, QuickPrintData, QuickPrintError, QuickPrintResponse, RecalculateOrderTotalsData, RecalculateOrderTotalsError, RecalculateOrderTotalsResponse, RefreshData, RefreshResponse2, RefreshTokenData, RefreshTokenResponse2, RefundPaymentData, RefundPaymentError, RefundPaymentResponse, ReindexSearchData, ReindexSearchResponse, ReleaseLockData, ReleaseLockResponse, RenewLockData, RenewLockError, RenewLockResponse, ResetPasswordData, ResetPasswordError, ResetPasswordResponse, RetryFailedJobData, RetryFailedJobError, RetryFailedJobResponse, RetryPrintJobData, RetryPrintJobError, RetryPrintJobResponse, SaveCartonsData, SaveCartonsError, SaveCartonsResponse, SearchCustomersData, SearchCustomersResponse, SearchDesignsData, SearchDesignsResponse, SearchOrdersData, SearchOrdersResponse, SearchProductsData, SearchProductsResponse, SelectAckTemplateData, SelectAckTemplateError, SelectAckTemplateResponse, SendInvoiceEmailAsyncData, SendInvoiceEmailSyncData, SendInvoiceEmailSyncError, SendInvoiceEmailSyncResponse, SendOrderConfirmationAsyncData, SendOrderConfirmationSyncData, SendOrderConfirmationSyncError, SendOrderConfirmationSyncResponse, SendShippingNotificationAsyncData, SendShippingNotificationSyncData, SendShippingNotificationSyncError, SendShippingNotificationSyncResponse, StartBatchGoldenrodPrintData, StartBatchGoldenrodPrintError, StartBatchGoldenrodPrintResponse, StartBatchInvoiceTransmissionData, StartBatchInvoiceTransmissionResponse, TestColdFoilPrinterConnectionData, TestColdFoilPrinterConnectionError, TestColdFoilPrinterConnectionResponse, TestTaxJarConnectionData, TestTaxJarConnectionResponse, TrackShipmentData, TrackShipmentError, TrackShipmentResponse, TriggerBatchMaterializationData, TriggerBatchMaterializationError, TriggerBatchMaterializationResponse2, TriggerMaterializationData, TriggerMaterializationError, TriggerMaterializationResponse2, TriggerRecurringJobData, TriggerRecurringJobResponse, UpdateAccessGroupData, UpdateAccessGroupError, UpdateAccessGroupResponse, UpdateAckTemplateData, UpdateAckTemplateError, UpdateAckTemplateResponse, UpdateAlertData, UpdateAlertError, UpdateAlertResponse, UpdateArtworkRequestData, UpdateArtworkRequestError, UpdateArtworkRequestResponse, UpdateArtworkStatusData, UpdateArtworkStatusError, UpdateArtworkStatusResponse, UpdateChargeItemData, UpdateChargeItemError, UpdateChargeItemResponse, UpdateChatSessionTitleData, UpdateChatSessionTitleError, UpdateChatSessionTitleResponse, UpdateColdFoilPrinterData, UpdateColdFoilPrinterError, UpdateColdFoilPrinterResponse, UpdateCompanyDefaultsData, UpdateCompanyDefaultsError, UpdateCompanyDefaultsResponse, UpdateCustomerData, UpdateCustomerError, UpdateCustomerResponse, UpdateCustomerTypeData, UpdateCustomerTypeError, UpdateCustomerTypeResponse, UpdateDesignCategoryData, UpdateDesignCategoryError, UpdateDesignCategoryResponse, UpdateDesignData, UpdateDesignError, UpdateDesignResponse, UpdateDivisionData, UpdateDivisionError, UpdateDivisionResponse, UpdateEmailSettingData, UpdateEmailSettingError, UpdateEmailSettingResponse, UpdateHpShipMethodData, UpdateHpShipMethodError, UpdateHpShipMethodResponse, UpdateLayoutSurfaceProfileData, UpdateLayoutSurfaceProfileError, UpdateLayoutSurfaceProfileResponse, UpdateLocationCodeData, UpdateLocationCodeError, UpdateLocationCodeResponse, UpdateMenuItemData, UpdateMenuItemError, UpdateMenuItemResponse, UpdateNonShipDateData, UpdateNonShipDateError, UpdateNonShipDateResponse, UpdateOptionValueData, UpdateOptionValueError, UpdateOptionValueResponse, UpdateOrderChartsData, UpdateOrderChartsError, UpdateOrderChartsResponse, UpdateOrderData, UpdateOrderDocumentData, UpdateOrderDocumentError, UpdateOrderDocumentResponse, UpdateOrderError, UpdateOrderResponse, UpdateOrderStatusData, UpdateOrderStatusError, UpdateOrderStatusResponse, UpdateOrderTotalsData, UpdateOrderTotalsError, UpdateOrderTotalsResponse, UpdatePriceDetailData, UpdatePriceDetailError, UpdatePriceDetailResponse, UpdatePriceHeaderData, UpdatePriceHeaderError, UpdatePriceHeaderResponse, UpdatePrinterData, UpdatePrinterError, UpdatePrinterResponse, UpdateProductData, UpdateProductError, UpdateProductResponse, UpdateProductSpecData, UpdateProductSpecError, UpdateProductSpecResponse, UpdateReturnRecallData, UpdateReturnRecallError, UpdateReturnRecallResponse, UpdateShippingDefaultData, UpdateShippingDefaultError, UpdateShippingDefaultResponse, UpdateShippingSpecialInstructionData, UpdateShippingSpecialInstructionError, UpdateShippingSpecialInstructionResponse, UpdateShipToData, UpdateShipToError, UpdateShipToResponse, UpdateTextSnippetData, UpdateTextSnippetError, UpdateTextSnippetResponse, UpdateUserData, UpdateUserError, UpdateUserResponse, UploadArtworkRequestImageData, UploadArtworkRequestImageError, UploadArtworkRequestImageResponse, UploadOrderAttachmentData, UploadOrderAttachmentError, UploadOrderAttachmentResponse, ValidateShippingAddressData, ValidateShippingAddressError, ValidateShippingAddressResponse, VoidPaymentData, VoidPaymentError, VoidPaymentResponse, VoidShipmentData, VoidShipmentError, VoidShipmentResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const healthCheckQueryKey = (options?: Options<HealthCheckData>) => createQueryKey('healthCheck', options);

export const healthCheckOptions = (options?: Options<HealthCheckData>) => queryOptions<HealthCheckResponse2, DefaultError, HealthCheckResponse2, ReturnType<typeof healthCheckQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthCheck({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: healthCheckQueryKey(options)
});

export const pingQueryKey = (options?: Options<PingData>) => createQueryKey('ping', options);

/**
 * Verify Mediator pipeline dispatches correctly
 */
export const pingOptions = (options?: Options<PingData>) => queryOptions<PingResponse2, DefaultError, PingResponse2, ReturnType<typeof pingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await ping({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: pingQueryKey(options)
});

/**
 * Authenticate with username and password
 */
export const loginMutation = (options?: Partial<Options<LoginData>>): UseMutationOptions<LoginResponse2, DefaultError, Options<LoginData>> => {
    const mutationOptions: UseMutationOptions<LoginResponse2, DefaultError, Options<LoginData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await login({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh access token using HttpOnly cookie
 */
export const refreshMutation = (options?: Partial<Options<RefreshData>>): UseMutationOptions<RefreshResponse2, DefaultError, Options<RefreshData>> => {
    const mutationOptions: UseMutationOptions<RefreshResponse2, DefaultError, Options<RefreshData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refresh({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refresh access token using explicit refresh token body (for non-browser clients)
 */
export const refreshTokenMutation = (options?: Partial<Options<RefreshTokenData>>): UseMutationOptions<RefreshTokenResponse2, DefaultError, Options<RefreshTokenData>> => {
    const mutationOptions: UseMutationOptions<RefreshTokenResponse2, DefaultError, Options<RefreshTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refreshToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Revoke refresh token and clear cookie
 */
export const logoutMutation = (options?: Partial<Options<LogoutData>>): UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> => {
    const mutationOptions: UseMutationOptions<LogoutResponse, DefaultError, Options<LogoutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await logout({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listUsersQueryKey = (options?: Options<ListUsersData>) => createQueryKey('listUsers', options);

/**
 * Get paginated list of users
 */
export const listUsersOptions = (options?: Options<ListUsersData>) => queryOptions<ListUsersResponse, DefaultError, ListUsersResponse, ReturnType<typeof listUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUsersQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const listUsersInfiniteQueryKey = (options?: Options<ListUsersData>): QueryKey<Options<ListUsersData>> => createQueryKey('listUsers', options, true);

/**
 * Get paginated list of users
 */
export const listUsersInfiniteOptions = (options?: Options<ListUsersData>) => infiniteQueryOptions<ListUsersResponse, DefaultError, InfiniteData<ListUsersResponse>, QueryKey<Options<ListUsersData>>, number | string | Pick<QueryKey<Options<ListUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listUsers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listUsersInfiniteQueryKey(options)
});

/**
 * Create a new user
 */
export const createUserMutation = (options?: Partial<Options<CreateUserData>>): UseMutationOptions<CreateUserResponse, CreateUserError, Options<CreateUserData>> => {
    const mutationOptions: UseMutationOptions<CreateUserResponse, CreateUserError, Options<CreateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Soft-delete (deactivate) a user
 */
export const deleteUserMutation = (options?: Partial<Options<DeleteUserData>>): UseMutationOptions<DeleteUserResponse, DeleteUserError, Options<DeleteUserData>> => {
    const mutationOptions: UseMutationOptions<DeleteUserResponse, DeleteUserError, Options<DeleteUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUserQueryKey = (options: Options<GetUserData>) => createQueryKey('getUser', options);

/**
 * Get a single user by ID
 */
export const getUserOptions = (options: Options<GetUserData>) => queryOptions<GetUserResponse, GetUserError, GetUserResponse, ReturnType<typeof getUserQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getUser({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getUserQueryKey(options)
});

/**
 * Update an existing user
 */
export const updateUserMutation = (options?: Partial<Options<UpdateUserData>>): UseMutationOptions<UpdateUserResponse, UpdateUserError, Options<UpdateUserData>> => {
    const mutationOptions: UseMutationOptions<UpdateUserResponse, UpdateUserError, Options<UpdateUserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateUser({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Admin password reset for a user
 */
export const resetPasswordMutation = (options?: Partial<Options<ResetPasswordData>>): UseMutationOptions<ResetPasswordResponse, ResetPasswordError, Options<ResetPasswordData>> => {
    const mutationOptions: UseMutationOptions<ResetPasswordResponse, ResetPasswordError, Options<ResetPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await resetPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAccessGroupsQueryKey = (options?: Options<ListAccessGroupsData>) => createQueryKey('listAccessGroups', options);

/**
 * Get all access groups
 */
export const listAccessGroupsOptions = (options?: Options<ListAccessGroupsData>) => queryOptions<ListAccessGroupsResponse, DefaultError, ListAccessGroupsResponse, ReturnType<typeof listAccessGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAccessGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAccessGroupsQueryKey(options)
});

/**
 * Create a new access group
 */
export const createAccessGroupMutation = (options?: Partial<Options<CreateAccessGroupData>>): UseMutationOptions<CreateAccessGroupResponse, CreateAccessGroupError, Options<CreateAccessGroupData>> => {
    const mutationOptions: UseMutationOptions<CreateAccessGroupResponse, CreateAccessGroupError, Options<CreateAccessGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAccessGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an access group (fails if users are assigned)
 */
export const deleteAccessGroupMutation = (options?: Partial<Options<DeleteAccessGroupData>>): UseMutationOptions<DeleteAccessGroupResponse, DeleteAccessGroupError, Options<DeleteAccessGroupData>> => {
    const mutationOptions: UseMutationOptions<DeleteAccessGroupResponse, DeleteAccessGroupError, Options<DeleteAccessGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAccessGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAccessGroupQueryKey = (options: Options<GetAccessGroupData>) => createQueryKey('getAccessGroup', options);

/**
 * Get a single access group with permissions
 */
export const getAccessGroupOptions = (options: Options<GetAccessGroupData>) => queryOptions<GetAccessGroupResponse, GetAccessGroupError, GetAccessGroupResponse, ReturnType<typeof getAccessGroupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getAccessGroup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getAccessGroupQueryKey(options)
});

/**
 * Update an access group and its permissions
 */
export const updateAccessGroupMutation = (options?: Partial<Options<UpdateAccessGroupData>>): UseMutationOptions<UpdateAccessGroupResponse, UpdateAccessGroupError, Options<UpdateAccessGroupData>> => {
    const mutationOptions: UseMutationOptions<UpdateAccessGroupResponse, UpdateAccessGroupError, Options<UpdateAccessGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAccessGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAlertsQueryKey = (options?: Options<ListAlertsData>) => createQueryKey('listAlerts', options);

/**
 * Get all alerts ordered by start date
 */
export const listAlertsOptions = (options?: Options<ListAlertsData>) => queryOptions<ListAlertsResponse, DefaultError, ListAlertsResponse, ReturnType<typeof listAlertsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAlerts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAlertsQueryKey(options)
});

/**
 * Create a new alert
 */
export const createAlertMutation = (options?: Partial<Options<CreateAlertData>>): UseMutationOptions<CreateAlertResponse, CreateAlertError, Options<CreateAlertData>> => {
    const mutationOptions: UseMutationOptions<CreateAlertResponse, CreateAlertError, Options<CreateAlertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAlert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an alert
 */
export const deleteAlertMutation = (options?: Partial<Options<DeleteAlertData>>): UseMutationOptions<DeleteAlertResponse, DeleteAlertError, Options<DeleteAlertData>> => {
    const mutationOptions: UseMutationOptions<DeleteAlertResponse, DeleteAlertError, Options<DeleteAlertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAlert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an existing alert
 */
export const updateAlertMutation = (options?: Partial<Options<UpdateAlertData>>): UseMutationOptions<UpdateAlertResponse, UpdateAlertError, Options<UpdateAlertData>> => {
    const mutationOptions: UseMutationOptions<UpdateAlertResponse, UpdateAlertError, Options<UpdateAlertData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAlert({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Release a record lock
 */
export const releaseLockMutation = (options?: Partial<Options<ReleaseLockData>>): UseMutationOptions<ReleaseLockResponse, DefaultError, Options<ReleaseLockData>> => {
    const mutationOptions: UseMutationOptions<ReleaseLockResponse, DefaultError, Options<ReleaseLockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await releaseLock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Acquire a record lock for editing
 */
export const acquireLockMutation = (options?: Partial<Options<AcquireLockData>>): UseMutationOptions<AcquireLockResponse, AcquireLockError, Options<AcquireLockData>> => {
    const mutationOptions: UseMutationOptions<AcquireLockResponse, AcquireLockError, Options<AcquireLockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await acquireLock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Renew (heartbeat) an existing record lock
 */
export const renewLockMutation = (options?: Partial<Options<RenewLockData>>): UseMutationOptions<RenewLockResponse, RenewLockError, Options<RenewLockData>> => {
    const mutationOptions: UseMutationOptions<RenewLockResponse, RenewLockError, Options<RenewLockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await renewLock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const checkLockQueryKey = (options: Options<CheckLockData>) => createQueryKey('checkLock', options);

/**
 * Check if a record is currently locked
 */
export const checkLockOptions = (options: Options<CheckLockData>) => queryOptions<CheckLockResponse2, DefaultError, CheckLockResponse2, ReturnType<typeof checkLockQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await checkLock({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: checkLockQueryKey(options)
});

export const listLockedRecordsQueryKey = (options?: Options<ListLockedRecordsData>) => createQueryKey('listLockedRecords', options);

/**
 * Get all active locked records
 */
export const listLockedRecordsOptions = (options?: Options<ListLockedRecordsData>) => queryOptions<ListLockedRecordsResponse, DefaultError, ListLockedRecordsResponse, ReturnType<typeof listLockedRecordsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listLockedRecords({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listLockedRecordsQueryKey(options)
});

/**
 * Force unlock a record (admin)
 */
export const forceUnlockMutation = (options?: Partial<Options<ForceUnlockData>>): UseMutationOptions<ForceUnlockResponse, DefaultError, Options<ForceUnlockData>> => {
    const mutationOptions: UseMutationOptions<ForceUnlockResponse, DefaultError, Options<ForceUnlockData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await forceUnlock({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listChangeLogQueryKey = (options?: Options<ListChangeLogData>) => createQueryKey('listChangeLog', options);

/**
 * Get paginated change log entries with optional filters
 */
export const listChangeLogOptions = (options?: Options<ListChangeLogData>) => queryOptions<ListChangeLogResponse, DefaultError, ListChangeLogResponse, ReturnType<typeof listChangeLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listChangeLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChangeLogQueryKey(options)
});

export const listChangeLogInfiniteQueryKey = (options?: Options<ListChangeLogData>): QueryKey<Options<ListChangeLogData>> => createQueryKey('listChangeLog', options, true);

/**
 * Get paginated change log entries with optional filters
 */
export const listChangeLogInfiniteOptions = (options?: Options<ListChangeLogData>) => infiniteQueryOptions<ListChangeLogResponse, DefaultError, InfiniteData<ListChangeLogResponse>, QueryKey<Options<ListChangeLogData>>, number | string | Pick<QueryKey<Options<ListChangeLogData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListChangeLogData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listChangeLog({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChangeLogInfiniteQueryKey(options)
});

export const listDivisionsQueryKey = (options?: Options<ListDivisionsData>) => createQueryKey('listDivisions', options);

/**
 * Get all divisions
 */
export const listDivisionsOptions = (options?: Options<ListDivisionsData>) => queryOptions<ListDivisionsResponse, DefaultError, ListDivisionsResponse, ReturnType<typeof listDivisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDivisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDivisionsQueryKey(options)
});

/**
 * Update a division
 */
export const updateDivisionMutation = (options?: Partial<Options<UpdateDivisionData>>): UseMutationOptions<UpdateDivisionResponse, UpdateDivisionError, Options<UpdateDivisionData>> => {
    const mutationOptions: UseMutationOptions<UpdateDivisionResponse, UpdateDivisionError, Options<UpdateDivisionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDivision({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCompanyDefaultsQueryKey = (options?: Options<GetCompanyDefaultsData>) => createQueryKey('getCompanyDefaults', options);

/**
 * Get company defaults
 */
export const getCompanyDefaultsOptions = (options?: Options<GetCompanyDefaultsData>) => queryOptions<GetCompanyDefaultsResponse, GetCompanyDefaultsError, GetCompanyDefaultsResponse, ReturnType<typeof getCompanyDefaultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCompanyDefaults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCompanyDefaultsQueryKey(options)
});

/**
 * Update company defaults
 */
export const updateCompanyDefaultsMutation = (options?: Partial<Options<UpdateCompanyDefaultsData>>): UseMutationOptions<UpdateCompanyDefaultsResponse, UpdateCompanyDefaultsError, Options<UpdateCompanyDefaultsData>> => {
    const mutationOptions: UseMutationOptions<UpdateCompanyDefaultsResponse, UpdateCompanyDefaultsError, Options<UpdateCompanyDefaultsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCompanyDefaults({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listMenuItemsQueryKey = (options?: Options<ListMenuItemsData>) => createQueryKey('listMenuItems', options);

/**
 * Get all menu items as a tree structure
 */
export const listMenuItemsOptions = (options?: Options<ListMenuItemsData>) => queryOptions<ListMenuItemsResponse, DefaultError, ListMenuItemsResponse, ReturnType<typeof listMenuItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listMenuItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listMenuItemsQueryKey(options)
});

/**
 * Update a menu item
 */
export const updateMenuItemMutation = (options?: Partial<Options<UpdateMenuItemData>>): UseMutationOptions<UpdateMenuItemResponse, UpdateMenuItemError, Options<UpdateMenuItemData>> => {
    const mutationOptions: UseMutationOptions<UpdateMenuItemResponse, UpdateMenuItemError, Options<UpdateMenuItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateMenuItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSalesRepsQueryKey = (options?: Options<ListSalesRepsData>) => createQueryKey('listSalesReps', options);

/**
 * Get all sales reps
 */
export const listSalesRepsOptions = (options?: Options<ListSalesRepsData>) => queryOptions<ListSalesRepsResponse, DefaultError, ListSalesRepsResponse, ReturnType<typeof listSalesRepsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSalesReps({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSalesRepsQueryKey(options)
});

export const listTermsCodesQueryKey = (options?: Options<ListTermsCodesData>) => createQueryKey('listTermsCodes', options);

/**
 * Get all terms codes
 */
export const listTermsCodesOptions = (options?: Options<ListTermsCodesData>) => queryOptions<ListTermsCodesResponse, DefaultError, ListTermsCodesResponse, ReturnType<typeof listTermsCodesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTermsCodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTermsCodesQueryKey(options)
});

export const listShipMethodsQueryKey = (options?: Options<ListShipMethodsData>) => createQueryKey('listShipMethods', options);

/**
 * Get all ship methods
 */
export const listShipMethodsOptions = (options?: Options<ListShipMethodsData>) => queryOptions<ListShipMethodsResponse, DefaultError, ListShipMethodsResponse, ReturnType<typeof listShipMethodsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listShipMethods({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listShipMethodsQueryKey(options)
});

export const listNonShipDatesQueryKey = (options?: Options<ListNonShipDatesData>) => createQueryKey('listNonShipDates', options);

/**
 * Get all non-ship dates for a year, grouped by date with divisions
 */
export const listNonShipDatesOptions = (options?: Options<ListNonShipDatesData>) => queryOptions<ListNonShipDatesResponse, DefaultError, ListNonShipDatesResponse, ReturnType<typeof listNonShipDatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listNonShipDates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listNonShipDatesQueryKey(options)
});

/**
 * Create a non-ship date with division assignments
 */
export const createNonShipDateMutation = (options?: Partial<Options<CreateNonShipDateData>>): UseMutationOptions<CreateNonShipDateResponse, CreateNonShipDateError, Options<CreateNonShipDateData>> => {
    const mutationOptions: UseMutationOptions<CreateNonShipDateResponse, CreateNonShipDateError, Options<CreateNonShipDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createNonShipDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete all non-ship date entries for a specific date
 */
export const deleteNonShipDateMutation = (options?: Partial<Options<DeleteNonShipDateData>>): UseMutationOptions<DeleteNonShipDateResponse, DeleteNonShipDateError, Options<DeleteNonShipDateData>> => {
    const mutationOptions: UseMutationOptions<DeleteNonShipDateResponse, DeleteNonShipDateError, Options<DeleteNonShipDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteNonShipDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a non-ship date's name and division assignments
 */
export const updateNonShipDateMutation = (options?: Partial<Options<UpdateNonShipDateData>>): UseMutationOptions<UpdateNonShipDateResponse, UpdateNonShipDateError, Options<UpdateNonShipDateData>> => {
    const mutationOptions: UseMutationOptions<UpdateNonShipDateResponse, UpdateNonShipDateError, Options<UpdateNonShipDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateNonShipDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listHpShipMethodsQueryKey = (options?: Options<ListHpShipMethodsData>) => createQueryKey('listHpShipMethods', options);

/**
 * Get all per-division ship methods with surcharges and geo restrictions
 */
export const listHpShipMethodsOptions = (options?: Options<ListHpShipMethodsData>) => queryOptions<ListHpShipMethodsResponse, DefaultError, ListHpShipMethodsResponse, ReturnType<typeof listHpShipMethodsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listHpShipMethods({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listHpShipMethodsQueryKey(options)
});

/**
 * Create a new per-division ship method
 */
export const createHpShipMethodMutation = (options?: Partial<Options<CreateHpShipMethodData>>): UseMutationOptions<CreateHpShipMethodResponse, CreateHpShipMethodError, Options<CreateHpShipMethodData>> => {
    const mutationOptions: UseMutationOptions<CreateHpShipMethodResponse, CreateHpShipMethodError, Options<CreateHpShipMethodData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createHpShipMethod({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a per-division ship method
 */
export const deleteHpShipMethodMutation = (options?: Partial<Options<DeleteHpShipMethodData>>): UseMutationOptions<DeleteHpShipMethodResponse, DeleteHpShipMethodError, Options<DeleteHpShipMethodData>> => {
    const mutationOptions: UseMutationOptions<DeleteHpShipMethodResponse, DeleteHpShipMethodError, Options<DeleteHpShipMethodData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteHpShipMethod({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an existing per-division ship method
 */
export const updateHpShipMethodMutation = (options?: Partial<Options<UpdateHpShipMethodData>>): UseMutationOptions<UpdateHpShipMethodResponse, UpdateHpShipMethodError, Options<UpdateHpShipMethodData>> => {
    const mutationOptions: UseMutationOptions<UpdateHpShipMethodResponse, UpdateHpShipMethodError, Options<UpdateHpShipMethodData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateHpShipMethod({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listShippingSpecialInstructionsQueryKey = (options?: Options<ListShippingSpecialInstructionsData>) => createQueryKey('listShippingSpecialInstructions', options);

/**
 * Get all shipping special instructions
 */
export const listShippingSpecialInstructionsOptions = (options?: Options<ListShippingSpecialInstructionsData>) => queryOptions<ListShippingSpecialInstructionsResponse, DefaultError, ListShippingSpecialInstructionsResponse, ReturnType<typeof listShippingSpecialInstructionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listShippingSpecialInstructions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listShippingSpecialInstructionsQueryKey(options)
});

/**
 * Create a new shipping special instruction
 */
export const createShippingSpecialInstructionMutation = (options?: Partial<Options<CreateShippingSpecialInstructionData>>): UseMutationOptions<CreateShippingSpecialInstructionResponse, CreateShippingSpecialInstructionError, Options<CreateShippingSpecialInstructionData>> => {
    const mutationOptions: UseMutationOptions<CreateShippingSpecialInstructionResponse, CreateShippingSpecialInstructionError, Options<CreateShippingSpecialInstructionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createShippingSpecialInstruction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a shipping special instruction
 */
export const deleteShippingSpecialInstructionMutation = (options?: Partial<Options<DeleteShippingSpecialInstructionData>>): UseMutationOptions<DeleteShippingSpecialInstructionResponse, DeleteShippingSpecialInstructionError, Options<DeleteShippingSpecialInstructionData>> => {
    const mutationOptions: UseMutationOptions<DeleteShippingSpecialInstructionResponse, DeleteShippingSpecialInstructionError, Options<DeleteShippingSpecialInstructionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteShippingSpecialInstruction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an existing shipping special instruction
 */
export const updateShippingSpecialInstructionMutation = (options?: Partial<Options<UpdateShippingSpecialInstructionData>>): UseMutationOptions<UpdateShippingSpecialInstructionResponse, UpdateShippingSpecialInstructionError, Options<UpdateShippingSpecialInstructionData>> => {
    const mutationOptions: UseMutationOptions<UpdateShippingSpecialInstructionResponse, UpdateShippingSpecialInstructionError, Options<UpdateShippingSpecialInstructionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateShippingSpecialInstruction({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listShippingDefaultsQueryKey = (options?: Options<ListShippingDefaultsData>) => createQueryKey('listShippingDefaults', options);

/**
 * Get all shipping defaults per division
 */
export const listShippingDefaultsOptions = (options?: Options<ListShippingDefaultsData>) => queryOptions<ListShippingDefaultsResponse, DefaultError, ListShippingDefaultsResponse, ReturnType<typeof listShippingDefaultsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listShippingDefaults({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listShippingDefaultsQueryKey(options)
});

/**
 * Update UPS credentials and shipper address for a division
 */
export const updateShippingDefaultMutation = (options?: Partial<Options<UpdateShippingDefaultData>>): UseMutationOptions<UpdateShippingDefaultResponse, UpdateShippingDefaultError, Options<UpdateShippingDefaultData>> => {
    const mutationOptions: UseMutationOptions<UpdateShippingDefaultResponse, UpdateShippingDefaultError, Options<UpdateShippingDefaultData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateShippingDefault({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listLocationCodesQueryKey = (options?: Options<ListLocationCodesData>) => createQueryKey('listLocationCodes', options);

/**
 * Get all production location codes
 */
export const listLocationCodesOptions = (options?: Options<ListLocationCodesData>) => queryOptions<ListLocationCodesResponse, DefaultError, ListLocationCodesResponse, ReturnType<typeof listLocationCodesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listLocationCodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listLocationCodesQueryKey(options)
});

/**
 * Create a new production location code
 */
export const createLocationCodeMutation = (options?: Partial<Options<CreateLocationCodeData>>): UseMutationOptions<CreateLocationCodeResponse, CreateLocationCodeError, Options<CreateLocationCodeData>> => {
    const mutationOptions: UseMutationOptions<CreateLocationCodeResponse, CreateLocationCodeError, Options<CreateLocationCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createLocationCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a production location code
 */
export const deleteLocationCodeMutation = (options?: Partial<Options<DeleteLocationCodeData>>): UseMutationOptions<DeleteLocationCodeResponse, DeleteLocationCodeError, Options<DeleteLocationCodeData>> => {
    const mutationOptions: UseMutationOptions<DeleteLocationCodeResponse, DeleteLocationCodeError, Options<DeleteLocationCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteLocationCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an existing production location code
 */
export const updateLocationCodeMutation = (options?: Partial<Options<UpdateLocationCodeData>>): UseMutationOptions<UpdateLocationCodeResponse, UpdateLocationCodeError, Options<UpdateLocationCodeData>> => {
    const mutationOptions: UseMutationOptions<UpdateLocationCodeResponse, UpdateLocationCodeError, Options<UpdateLocationCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateLocationCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTaxJarConfigQueryKey = (options?: Options<GetTaxJarConfigData>) => createQueryKey('getTaxJarConfig', options);

/**
 * Get current TaxJar configuration (read-only, from appsettings)
 */
export const getTaxJarConfigOptions = (options?: Options<GetTaxJarConfigData>) => queryOptions<GetTaxJarConfigResponse, DefaultError, GetTaxJarConfigResponse, ReturnType<typeof getTaxJarConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTaxJarConfig({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaxJarConfigQueryKey(options)
});

/**
 * Test TaxJar API connectivity using the configured credentials
 */
export const testTaxJarConnectionMutation = (options?: Partial<Options<TestTaxJarConnectionData>>): UseMutationOptions<TestTaxJarConnectionResponse, DefaultError, Options<TestTaxJarConnectionData>> => {
    const mutationOptions: UseMutationOptions<TestTaxJarConnectionResponse, DefaultError, Options<TestTaxJarConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await testTaxJarConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getJobDashboardQueryKey = (options?: Options<GetJobDashboardData>) => createQueryKey('getJobDashboard', options);

/**
 * Get background job summary counts and recurring job list
 */
export const getJobDashboardOptions = (options?: Options<GetJobDashboardData>) => queryOptions<GetJobDashboardResponse, DefaultError, GetJobDashboardResponse, ReturnType<typeof getJobDashboardQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobDashboard({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobDashboardQueryKey(options)
});

export const getJobDashboardInfiniteQueryKey = (options?: Options<GetJobDashboardData>): QueryKey<Options<GetJobDashboardData>> => createQueryKey('getJobDashboard', options, true);

/**
 * Get background job summary counts and recurring job list
 */
export const getJobDashboardInfiniteOptions = (options?: Options<GetJobDashboardData>) => infiniteQueryOptions<GetJobDashboardResponse, DefaultError, InfiniteData<GetJobDashboardResponse>, QueryKey<Options<GetJobDashboardData>>, number | string | Pick<QueryKey<Options<GetJobDashboardData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetJobDashboardData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getJobDashboard({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobDashboardInfiniteQueryKey(options)
});

export const getFailedJobsQueryKey = (options?: Options<GetFailedJobsData>) => createQueryKey('getFailedJobs', options);

/**
 * Get paginated list of failed background jobs
 */
export const getFailedJobsOptions = (options?: Options<GetFailedJobsData>) => queryOptions<GetFailedJobsResponse, DefaultError, GetFailedJobsResponse, ReturnType<typeof getFailedJobsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getFailedJobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFailedJobsQueryKey(options)
});

export const getFailedJobsInfiniteQueryKey = (options?: Options<GetFailedJobsData>): QueryKey<Options<GetFailedJobsData>> => createQueryKey('getFailedJobs', options, true);

/**
 * Get paginated list of failed background jobs
 */
export const getFailedJobsInfiniteOptions = (options?: Options<GetFailedJobsData>) => infiniteQueryOptions<GetFailedJobsResponse, DefaultError, InfiniteData<GetFailedJobsResponse>, QueryKey<Options<GetFailedJobsData>>, number | string | Pick<QueryKey<Options<GetFailedJobsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetFailedJobsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getFailedJobs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getFailedJobsInfiniteQueryKey(options)
});

export const getSucceededJobsQueryKey = (options?: Options<GetSucceededJobsData>) => createQueryKey('getSucceededJobs', options);

/**
 * Get paginated list of recently succeeded background jobs
 */
export const getSucceededJobsOptions = (options?: Options<GetSucceededJobsData>) => queryOptions<GetSucceededJobsResponse, DefaultError, GetSucceededJobsResponse, ReturnType<typeof getSucceededJobsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSucceededJobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSucceededJobsQueryKey(options)
});

export const getSucceededJobsInfiniteQueryKey = (options?: Options<GetSucceededJobsData>): QueryKey<Options<GetSucceededJobsData>> => createQueryKey('getSucceededJobs', options, true);

/**
 * Get paginated list of recently succeeded background jobs
 */
export const getSucceededJobsInfiniteOptions = (options?: Options<GetSucceededJobsData>) => infiniteQueryOptions<GetSucceededJobsResponse, DefaultError, InfiniteData<GetSucceededJobsResponse>, QueryKey<Options<GetSucceededJobsData>>, number | string | Pick<QueryKey<Options<GetSucceededJobsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetSucceededJobsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getSucceededJobs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSucceededJobsInfiniteQueryKey(options)
});

export const getJobDetailQueryKey = (options: Options<GetJobDetailData>) => createQueryKey('getJobDetail', options);

/**
 * Get detailed state history for a specific background job
 */
export const getJobDetailOptions = (options: Options<GetJobDetailData>) => queryOptions<GetJobDetailResponse, GetJobDetailError, GetJobDetailResponse, ReturnType<typeof getJobDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getJobDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getJobDetailQueryKey(options)
});

/**
 * Retry a failed background job
 */
export const retryFailedJobMutation = (options?: Partial<Options<RetryFailedJobData>>): UseMutationOptions<RetryFailedJobResponse, RetryFailedJobError, Options<RetryFailedJobData>> => {
    const mutationOptions: UseMutationOptions<RetryFailedJobResponse, RetryFailedJobError, Options<RetryFailedJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryFailedJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a background job
 */
export const deleteJobMutation = (options?: Partial<Options<DeleteJobData>>): UseMutationOptions<DeleteJobResponse, DeleteJobError, Options<DeleteJobData>> => {
    const mutationOptions: UseMutationOptions<DeleteJobResponse, DeleteJobError, Options<DeleteJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Manually trigger a recurring job to run now
 */
export const triggerRecurringJobMutation = (options?: Partial<Options<TriggerRecurringJobData>>): UseMutationOptions<TriggerRecurringJobResponse, DefaultError, Options<TriggerRecurringJobData>> => {
    const mutationOptions: UseMutationOptions<TriggerRecurringJobResponse, DefaultError, Options<TriggerRecurringJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triggerRecurringJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTimeSpentQueryKey = (options?: Options<ListTimeSpentData>) => createQueryKey('listTimeSpent', options);

/**
 * List time-spent sessions with optional filters
 */
export const listTimeSpentOptions = (options?: Options<ListTimeSpentData>) => queryOptions<ListTimeSpentResponse, DefaultError, ListTimeSpentResponse, ReturnType<typeof listTimeSpentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTimeSpent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTimeSpentQueryKey(options)
});

export const listTimeSpentInfiniteQueryKey = (options?: Options<ListTimeSpentData>): QueryKey<Options<ListTimeSpentData>> => createQueryKey('listTimeSpent', options, true);

/**
 * List time-spent sessions with optional filters
 */
export const listTimeSpentInfiniteOptions = (options?: Options<ListTimeSpentData>) => infiniteQueryOptions<ListTimeSpentResponse, DefaultError, InfiniteData<ListTimeSpentResponse>, QueryKey<Options<ListTimeSpentData>>, number | string | Pick<QueryKey<Options<ListTimeSpentData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListTimeSpentData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTimeSpent({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTimeSpentInfiniteQueryKey(options)
});

export const getTimeSpentSummaryQueryKey = (options?: Options<GetTimeSpentSummaryData>) => createQueryKey('getTimeSpentSummary', options);

/**
 * Aggregate time-spent statistics with per-user rollup
 */
export const getTimeSpentSummaryOptions = (options?: Options<GetTimeSpentSummaryData>) => queryOptions<GetTimeSpentSummaryResponse, DefaultError, GetTimeSpentSummaryResponse, ReturnType<typeof getTimeSpentSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTimeSpentSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTimeSpentSummaryQueryKey(options)
});

export const getTimeSpentChartsQueryKey = (options?: Options<GetTimeSpentChartsData>) => createQueryKey('getTimeSpentCharts', options);

/**
 * Chart-ready breakdowns of time spent by order, user, and day
 */
export const getTimeSpentChartsOptions = (options?: Options<GetTimeSpentChartsData>) => queryOptions<GetTimeSpentChartsResponse, DefaultError, GetTimeSpentChartsResponse, ReturnType<typeof getTimeSpentChartsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTimeSpentCharts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTimeSpentChartsQueryKey(options)
});

export const listLayoutSurfaceProfilesQueryKey = (options?: Options<ListLayoutSurfaceProfilesData>) => createQueryKey('listLayoutSurfaceProfiles', options);

/**
 * List all layout surface profiles
 */
export const listLayoutSurfaceProfilesOptions = (options?: Options<ListLayoutSurfaceProfilesData>) => queryOptions<ListLayoutSurfaceProfilesResponse, DefaultError, ListLayoutSurfaceProfilesResponse, ReturnType<typeof listLayoutSurfaceProfilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listLayoutSurfaceProfiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listLayoutSurfaceProfilesQueryKey(options)
});

/**
 * Create a new layout surface profile
 */
export const createLayoutSurfaceProfileMutation = (options?: Partial<Options<CreateLayoutSurfaceProfileData>>): UseMutationOptions<CreateLayoutSurfaceProfileResponse, DefaultError, Options<CreateLayoutSurfaceProfileData>> => {
    const mutationOptions: UseMutationOptions<CreateLayoutSurfaceProfileResponse, DefaultError, Options<CreateLayoutSurfaceProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createLayoutSurfaceProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a layout surface profile
 */
export const deleteLayoutSurfaceProfileMutation = (options?: Partial<Options<DeleteLayoutSurfaceProfileData>>): UseMutationOptions<unknown, DeleteLayoutSurfaceProfileError, Options<DeleteLayoutSurfaceProfileData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeleteLayoutSurfaceProfileError, Options<DeleteLayoutSurfaceProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteLayoutSurfaceProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLayoutSurfaceProfileQueryKey = (options: Options<GetLayoutSurfaceProfileData>) => createQueryKey('getLayoutSurfaceProfile', options);

/**
 * Get a layout surface profile by ID
 */
export const getLayoutSurfaceProfileOptions = (options: Options<GetLayoutSurfaceProfileData>) => queryOptions<GetLayoutSurfaceProfileResponse, GetLayoutSurfaceProfileError, GetLayoutSurfaceProfileResponse, ReturnType<typeof getLayoutSurfaceProfileQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getLayoutSurfaceProfile({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getLayoutSurfaceProfileQueryKey(options)
});

/**
 * Update a layout surface profile
 */
export const updateLayoutSurfaceProfileMutation = (options?: Partial<Options<UpdateLayoutSurfaceProfileData>>): UseMutationOptions<UpdateLayoutSurfaceProfileResponse, UpdateLayoutSurfaceProfileError, Options<UpdateLayoutSurfaceProfileData>> => {
    const mutationOptions: UseMutationOptions<UpdateLayoutSurfaceProfileResponse, UpdateLayoutSurfaceProfileError, Options<UpdateLayoutSurfaceProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateLayoutSurfaceProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Publish a draft layout surface profile
 */
export const publishLayoutSurfaceProfileMutation = (options?: Partial<Options<PublishLayoutSurfaceProfileData>>): UseMutationOptions<PublishLayoutSurfaceProfileResponse, PublishLayoutSurfaceProfileError, Options<PublishLayoutSurfaceProfileData>> => {
    const mutationOptions: UseMutationOptions<PublishLayoutSurfaceProfileResponse, PublishLayoutSurfaceProfileError, Options<PublishLayoutSurfaceProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await publishLayoutSurfaceProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listLayoutSurfaceBindingsQueryKey = (options?: Options<ListLayoutSurfaceBindingsData>) => createQueryKey('listLayoutSurfaceBindings', options);

/**
 * List layout surface bindings
 */
export const listLayoutSurfaceBindingsOptions = (options?: Options<ListLayoutSurfaceBindingsData>) => queryOptions<ListLayoutSurfaceBindingsResponse, DefaultError, ListLayoutSurfaceBindingsResponse, ReturnType<typeof listLayoutSurfaceBindingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listLayoutSurfaceBindings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listLayoutSurfaceBindingsQueryKey(options)
});

/**
 * Create a new product binding to a layout surface profile
 */
export const createLayoutSurfaceBindingMutation = (options?: Partial<Options<CreateLayoutSurfaceBindingData>>): UseMutationOptions<CreateLayoutSurfaceBindingResponse, DefaultError, Options<CreateLayoutSurfaceBindingData>> => {
    const mutationOptions: UseMutationOptions<CreateLayoutSurfaceBindingResponse, DefaultError, Options<CreateLayoutSurfaceBindingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createLayoutSurfaceBinding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Remove a product binding
 */
export const deleteLayoutSurfaceBindingMutation = (options?: Partial<Options<DeleteLayoutSurfaceBindingData>>): UseMutationOptions<unknown, DeleteLayoutSurfaceBindingError, Options<DeleteLayoutSurfaceBindingData>> => {
    const mutationOptions: UseMutationOptions<unknown, DeleteLayoutSurfaceBindingError, Options<DeleteLayoutSurfaceBindingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteLayoutSurfaceBinding({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCustomersFilterMetadataQueryKey = (options?: Options<GetCustomersFilterMetadataData>) => createQueryKey('getCustomersFilterMetadata', options);

/**
 * Get filter metadata for Customers list columns
 */
export const getCustomersFilterMetadataOptions = (options?: Options<GetCustomersFilterMetadataData>) => queryOptions<GetCustomersFilterMetadataResponse, DefaultError, GetCustomersFilterMetadataResponse, ReturnType<typeof getCustomersFilterMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCustomersFilterMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCustomersFilterMetadataQueryKey(options)
});

export const listCustomersQueryKey = (options?: Options<ListCustomersData>) => createQueryKey('listCustomers', options);

/**
 * Get paginated list of customers
 */
export const listCustomersOptions = (options?: Options<ListCustomersData>) => queryOptions<ListCustomersResponse, DefaultError, ListCustomersResponse, ReturnType<typeof listCustomersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCustomers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCustomersQueryKey(options)
});

export const listCustomersInfiniteQueryKey = (options?: Options<ListCustomersData>): QueryKey<Options<ListCustomersData>> => createQueryKey('listCustomers', options, true);

/**
 * Get paginated list of customers
 */
export const listCustomersInfiniteOptions = (options?: Options<ListCustomersData>) => infiniteQueryOptions<ListCustomersResponse, DefaultError, InfiniteData<ListCustomersResponse>, QueryKey<Options<ListCustomersData>>, number | string | Pick<QueryKey<Options<ListCustomersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListCustomersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listCustomers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCustomersInfiniteQueryKey(options)
});

/**
 * Create a new customer
 */
export const createCustomerMutation = (options?: Partial<Options<CreateCustomerData>>): UseMutationOptions<CreateCustomerResponse, CreateCustomerError, Options<CreateCustomerData>> => {
    const mutationOptions: UseMutationOptions<CreateCustomerResponse, CreateCustomerError, Options<CreateCustomerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCustomer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchCustomersQueryKey = (options?: Options<SearchCustomersData>) => createQueryKey('searchCustomers', options);

/**
 * Typeahead search for customers
 */
export const searchCustomersOptions = (options?: Options<SearchCustomersData>) => queryOptions<SearchCustomersResponse, DefaultError, SearchCustomersResponse, ReturnType<typeof searchCustomersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchCustomers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchCustomersQueryKey(options)
});

/**
 * Soft-delete (deactivate) a customer
 */
export const deleteCustomerMutation = (options?: Partial<Options<DeleteCustomerData>>): UseMutationOptions<DeleteCustomerResponse, DeleteCustomerError, Options<DeleteCustomerData>> => {
    const mutationOptions: UseMutationOptions<DeleteCustomerResponse, DeleteCustomerError, Options<DeleteCustomerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCustomer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCustomerQueryKey = (options: Options<GetCustomerData>) => createQueryKey('getCustomer', options);

/**
 * Get a single customer by ID
 */
export const getCustomerOptions = (options: Options<GetCustomerData>) => queryOptions<GetCustomerResponse, GetCustomerError, GetCustomerResponse, ReturnType<typeof getCustomerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCustomer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCustomerQueryKey(options)
});

/**
 * Update an existing customer
 */
export const updateCustomerMutation = (options?: Partial<Options<UpdateCustomerData>>): UseMutationOptions<UpdateCustomerResponse, UpdateCustomerError, Options<UpdateCustomerData>> => {
    const mutationOptions: UseMutationOptions<UpdateCustomerResponse, UpdateCustomerError, Options<UpdateCustomerData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCustomer({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCustomerCreditHoldQueryKey = (options: Options<GetCustomerCreditHoldData>) => createQueryKey('getCustomerCreditHold', options);

/**
 * Check customer credit hold status against Traverse AR data
 */
export const getCustomerCreditHoldOptions = (options: Options<GetCustomerCreditHoldData>) => queryOptions<GetCustomerCreditHoldResponse, DefaultError, GetCustomerCreditHoldResponse, ReturnType<typeof getCustomerCreditHoldQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCustomerCreditHold({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCustomerCreditHoldQueryKey(options)
});

export const listShipToQueryKey = (options: Options<ListShipToData>) => createQueryKey('listShipTo', options);

/**
 * Get all ship-to addresses for a customer
 */
export const listShipToOptions = (options: Options<ListShipToData>) => queryOptions<ListShipToResponse, DefaultError, ListShipToResponse, ReturnType<typeof listShipToQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listShipTo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listShipToQueryKey(options)
});

/**
 * Create a new ship-to address
 */
export const createShipToMutation = (options?: Partial<Options<CreateShipToData>>): UseMutationOptions<CreateShipToResponse, CreateShipToError, Options<CreateShipToData>> => {
    const mutationOptions: UseMutationOptions<CreateShipToResponse, CreateShipToError, Options<CreateShipToData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createShipTo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a ship-to address
 */
export const deleteShipToMutation = (options?: Partial<Options<DeleteShipToData>>): UseMutationOptions<DeleteShipToResponse, DeleteShipToError, Options<DeleteShipToData>> => {
    const mutationOptions: UseMutationOptions<DeleteShipToResponse, DeleteShipToError, Options<DeleteShipToData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteShipTo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a ship-to address
 */
export const updateShipToMutation = (options?: Partial<Options<UpdateShipToData>>): UseMutationOptions<UpdateShipToResponse, UpdateShipToError, Options<UpdateShipToData>> => {
    const mutationOptions: UseMutationOptions<UpdateShipToResponse, UpdateShipToError, Options<UpdateShipToData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateShipTo({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSalesHistoryQueryKey = (options: Options<GetSalesHistoryData>) => createQueryKey('getSalesHistory', options);

/**
 * Get sales history for a customer
 */
export const getSalesHistoryOptions = (options: Options<GetSalesHistoryData>) => queryOptions<GetSalesHistoryResponse, GetSalesHistoryError, GetSalesHistoryResponse, ReturnType<typeof getSalesHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSalesHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSalesHistoryQueryKey(options)
});

export const getCustomerArBalanceQueryKey = (options: Options<GetCustomerArBalanceData>) => createQueryKey('getCustomerArBalance', options);

/**
 * Get AR balance summary with aging buckets and credit data for a customer
 */
export const getCustomerArBalanceOptions = (options: Options<GetCustomerArBalanceData>) => queryOptions<GetCustomerArBalanceResponse, GetCustomerArBalanceError, GetCustomerArBalanceResponse, ReturnType<typeof getCustomerArBalanceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCustomerArBalance({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCustomerArBalanceQueryKey(options)
});

export const listCustomerArHistoryQueryKey = (options: Options<ListCustomerArHistoryData>) => createQueryKey('listCustomerArHistory', options);

/**
 * List paginated AR transactions (invoices, credit memos, debit memos) for a customer
 *
 * Returns an empty page if Traverse ERP is unavailable.
 */
export const listCustomerArHistoryOptions = (options: Options<ListCustomerArHistoryData>) => queryOptions<ListCustomerArHistoryResponse, DefaultError, ListCustomerArHistoryResponse, ReturnType<typeof listCustomerArHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCustomerArHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCustomerArHistoryQueryKey(options)
});

export const listCustomerArHistoryInfiniteQueryKey = (options: Options<ListCustomerArHistoryData>): QueryKey<Options<ListCustomerArHistoryData>> => createQueryKey('listCustomerArHistory', options, true);

/**
 * List paginated AR transactions (invoices, credit memos, debit memos) for a customer
 *
 * Returns an empty page if Traverse ERP is unavailable.
 */
export const listCustomerArHistoryInfiniteOptions = (options: Options<ListCustomerArHistoryData>) => infiniteQueryOptions<ListCustomerArHistoryResponse, DefaultError, InfiniteData<ListCustomerArHistoryResponse>, QueryKey<Options<ListCustomerArHistoryData>>, number | string | Pick<QueryKey<Options<ListCustomerArHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListCustomerArHistoryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listCustomerArHistory({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCustomerArHistoryInfiniteQueryKey(options)
});

export const listCustomerTypesQueryKey = (options?: Options<ListCustomerTypesData>) => createQueryKey('listCustomerTypes', options);

/**
 * Get all customer types, optionally filtered by division
 */
export const listCustomerTypesOptions = (options?: Options<ListCustomerTypesData>) => queryOptions<ListCustomerTypesResponse, DefaultError, ListCustomerTypesResponse, ReturnType<typeof listCustomerTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCustomerTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCustomerTypesQueryKey(options)
});

/**
 * Create a new customer type
 */
export const createCustomerTypeMutation = (options?: Partial<Options<CreateCustomerTypeData>>): UseMutationOptions<CreateCustomerTypeResponse, CreateCustomerTypeError, Options<CreateCustomerTypeData>> => {
    const mutationOptions: UseMutationOptions<CreateCustomerTypeResponse, CreateCustomerTypeError, Options<CreateCustomerTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCustomerType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a customer type
 */
export const deleteCustomerTypeMutation = (options?: Partial<Options<DeleteCustomerTypeData>>): UseMutationOptions<DeleteCustomerTypeResponse, DeleteCustomerTypeError, Options<DeleteCustomerTypeData>> => {
    const mutationOptions: UseMutationOptions<DeleteCustomerTypeResponse, DeleteCustomerTypeError, Options<DeleteCustomerTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCustomerType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a customer type
 */
export const updateCustomerTypeMutation = (options?: Partial<Options<UpdateCustomerTypeData>>): UseMutationOptions<UpdateCustomerTypeResponse, UpdateCustomerTypeError, Options<UpdateCustomerTypeData>> => {
    const mutationOptions: UseMutationOptions<UpdateCustomerTypeResponse, UpdateCustomerTypeError, Options<UpdateCustomerTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateCustomerType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listCustomerNotesQueryKey = (options: Options<ListCustomerNotesData>) => createQueryKey('listCustomerNotes', options);

/**
 * List all notes for a customer
 */
export const listCustomerNotesOptions = (options: Options<ListCustomerNotesData>) => queryOptions<ListCustomerNotesResponse, DefaultError, ListCustomerNotesResponse, ReturnType<typeof listCustomerNotesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listCustomerNotes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listCustomerNotesQueryKey(options)
});

/**
 * Create a new note on a customer
 */
export const createCustomerNoteMutation = (options?: Partial<Options<CreateCustomerNoteData>>): UseMutationOptions<CreateCustomerNoteResponse, CreateCustomerNoteError, Options<CreateCustomerNoteData>> => {
    const mutationOptions: UseMutationOptions<CreateCustomerNoteResponse, CreateCustomerNoteError, Options<CreateCustomerNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createCustomerNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const lookupThreeCxCustomerQueryKey = (options: Options<LookupThreeCxCustomerData>) => createQueryKey('lookupThreeCxCustomer', options);

/**
 * Lookup a customer for the 3CX CRM popup by phone number
 */
export const lookupThreeCxCustomerOptions = (options: Options<LookupThreeCxCustomerData>) => queryOptions<LookupThreeCxCustomerResponse, LookupThreeCxCustomerError, LookupThreeCxCustomerResponse, ReturnType<typeof lookupThreeCxCustomerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await lookupThreeCxCustomer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: lookupThreeCxCustomerQueryKey(options)
});

export const listDesignsQueryKey = (options?: Options<ListDesignsData>) => createQueryKey('listDesigns', options);

/**
 * Get paginated, filterable design list
 */
export const listDesignsOptions = (options?: Options<ListDesignsData>) => queryOptions<ListDesignsResponse, DefaultError, ListDesignsResponse, ReturnType<typeof listDesignsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDesigns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDesignsQueryKey(options)
});

export const listDesignsInfiniteQueryKey = (options?: Options<ListDesignsData>): QueryKey<Options<ListDesignsData>> => createQueryKey('listDesigns', options, true);

/**
 * Get paginated, filterable design list
 */
export const listDesignsInfiniteOptions = (options?: Options<ListDesignsData>) => infiniteQueryOptions<ListDesignsResponse, DefaultError, InfiniteData<ListDesignsResponse>, QueryKey<Options<ListDesignsData>>, number | string | Pick<QueryKey<Options<ListDesignsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListDesignsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listDesigns({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDesignsInfiniteQueryKey(options)
});

/**
 * Create a new design
 */
export const createDesignMutation = (options?: Partial<Options<CreateDesignData>>): UseMutationOptions<CreateDesignResponse, CreateDesignError, Options<CreateDesignData>> => {
    const mutationOptions: UseMutationOptions<CreateDesignResponse, CreateDesignError, Options<CreateDesignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createDesign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const searchDesignsQueryKey = (options?: Options<SearchDesignsData>) => createQueryKey('searchDesigns', options);

/**
 * Typeahead search for designs
 */
export const searchDesignsOptions = (options?: Options<SearchDesignsData>) => queryOptions<SearchDesignsResponse, DefaultError, SearchDesignsResponse, ReturnType<typeof searchDesignsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchDesigns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchDesignsQueryKey(options)
});

export const getDesignQueryKey = (options: Options<GetDesignData>) => createQueryKey('getDesign', options);

/**
 * Get a single design with variations and product uses
 */
export const getDesignOptions = (options: Options<GetDesignData>) => queryOptions<GetDesignResponse, GetDesignError, GetDesignResponse, ReturnType<typeof getDesignQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDesign({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDesignQueryKey(options)
});

/**
 * Update a design (with record lock)
 */
export const updateDesignMutation = (options?: Partial<Options<UpdateDesignData>>): UseMutationOptions<UpdateDesignResponse, UpdateDesignError, Options<UpdateDesignData>> => {
    const mutationOptions: UseMutationOptions<UpdateDesignResponse, UpdateDesignError, Options<UpdateDesignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDesign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listDesignCategoriesQueryKey = (options?: Options<ListDesignCategoriesData>) => createQueryKey('listDesignCategories', options);

/**
 * Get design category tree
 */
export const listDesignCategoriesOptions = (options?: Options<ListDesignCategoriesData>) => queryOptions<ListDesignCategoriesResponse, DefaultError, ListDesignCategoriesResponse, ReturnType<typeof listDesignCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDesignCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDesignCategoriesQueryKey(options)
});

/**
 * Update a design category
 */
export const updateDesignCategoryMutation = (options?: Partial<Options<UpdateDesignCategoryData>>): UseMutationOptions<UpdateDesignCategoryResponse, UpdateDesignCategoryError, Options<UpdateDesignCategoryData>> => {
    const mutationOptions: UseMutationOptions<UpdateDesignCategoryResponse, UpdateDesignCategoryError, Options<UpdateDesignCategoryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateDesignCategory({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrdersFilterMetadataQueryKey = (options?: Options<GetOrdersFilterMetadataData>) => createQueryKey('getOrdersFilterMetadata', options);

/**
 * Get filter metadata for Orders list columns
 */
export const getOrdersFilterMetadataOptions = (options?: Options<GetOrdersFilterMetadataData>) => queryOptions<GetOrdersFilterMetadataResponse, DefaultError, GetOrdersFilterMetadataResponse, ReturnType<typeof getOrdersFilterMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrdersFilterMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrdersFilterMetadataQueryKey(options)
});

export const listOrdersQueryKey = (options?: Options<ListOrdersData>) => createQueryKey('listOrders', options);

/**
 * Get paginated list of orders
 */
export const listOrdersOptions = (options?: Options<ListOrdersData>) => queryOptions<ListOrdersResponse, DefaultError, ListOrdersResponse, ReturnType<typeof listOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrdersQueryKey(options)
});

export const listOrdersInfiniteQueryKey = (options?: Options<ListOrdersData>): QueryKey<Options<ListOrdersData>> => createQueryKey('listOrders', options, true);

/**
 * Get paginated list of orders
 */
export const listOrdersInfiniteOptions = (options?: Options<ListOrdersData>) => infiniteQueryOptions<ListOrdersResponse, DefaultError, InfiniteData<ListOrdersResponse>, QueryKey<Options<ListOrdersData>>, number | string | Pick<QueryKey<Options<ListOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listOrders({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrdersInfiniteQueryKey(options)
});

/**
 * Create a new order
 */
export const createOrderMutation = (options?: Partial<Options<CreateOrderData>>): UseMutationOptions<CreateOrderResponse, CreateOrderError, Options<CreateOrderData>> => {
    const mutationOptions: UseMutationOptions<CreateOrderResponse, CreateOrderError, Options<CreateOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrderStatusesQueryKey = (options?: Options<ListOrderStatusesData>) => createQueryKey('listOrderStatuses', options);

/**
 * Get all order status codes
 */
export const listOrderStatusesOptions = (options?: Options<ListOrderStatusesData>) => queryOptions<ListOrderStatusesResponse, DefaultError, ListOrderStatusesResponse, ReturnType<typeof listOrderStatusesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrderStatuses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrderStatusesQueryKey(options)
});

export const searchOrdersQueryKey = (options?: Options<SearchOrdersData>) => createQueryKey('searchOrders', options);

/**
 * Typeahead search for orders
 */
export const searchOrdersOptions = (options?: Options<SearchOrdersData>) => queryOptions<SearchOrdersResponse, DefaultError, SearchOrdersResponse, ReturnType<typeof searchOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchOrdersQueryKey(options)
});

export const getOrderQueryKey = (options: Options<GetOrderData>) => createQueryKey('getOrder', options);

/**
 * Get a single order by TransId
 */
export const getOrderOptions = (options: Options<GetOrderData>) => queryOptions<GetOrderResponse, GetOrderError, GetOrderResponse, ReturnType<typeof getOrderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrder({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderQueryKey(options)
});

/**
 * Update an existing order
 */
export const updateOrderMutation = (options?: Partial<Options<UpdateOrderData>>): UseMutationOptions<UpdateOrderResponse, UpdateOrderError, Options<UpdateOrderData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrderResponse, UpdateOrderError, Options<UpdateOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrderLineItemsQueryKey = (options: Options<GetOrderLineItemsData>) => createQueryKey('getOrderLineItems', options);

/**
 * Get line items for an order
 */
export const getOrderLineItemsOptions = (options: Options<GetOrderLineItemsData>) => queryOptions<GetOrderLineItemsResponse, GetOrderLineItemsError, GetOrderLineItemsResponse, ReturnType<typeof getOrderLineItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderLineItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderLineItemsQueryKey(options)
});

export const getOrderActivityQueryKey = (options: Options<GetOrderActivityData>) => createQueryKey('getOrderActivity', options);

/**
 * Get activity log for an order
 */
export const getOrderActivityOptions = (options: Options<GetOrderActivityData>) => queryOptions<GetOrderActivityResponse, GetOrderActivityError, GetOrderActivityResponse, ReturnType<typeof getOrderActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderActivityQueryKey(options)
});

/**
 * Add a manual note to the order activity log
 */
export const addOrderNoteMutation = (options?: Partial<Options<AddOrderNoteData>>): UseMutationOptions<AddOrderNoteResponse, AddOrderNoteError, Options<AddOrderNoteData>> => {
    const mutationOptions: UseMutationOptions<AddOrderNoteResponse, AddOrderNoteError, Options<AddOrderNoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await addOrderNote({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrderDocumentsQueryKey = (options: Options<ListOrderDocumentsData>) => createQueryKey('listOrderDocuments', options);

/**
 * List all documents/notes for an order
 */
export const listOrderDocumentsOptions = (options: Options<ListOrderDocumentsData>) => queryOptions<ListOrderDocumentsResponse, DefaultError, ListOrderDocumentsResponse, ReturnType<typeof listOrderDocumentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrderDocuments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrderDocumentsQueryKey(options)
});

/**
 * Create a new document/note for an order
 */
export const createOrderDocumentMutation = (options?: Partial<Options<CreateOrderDocumentData>>): UseMutationOptions<CreateOrderDocumentResponse, CreateOrderDocumentError, Options<CreateOrderDocumentData>> => {
    const mutationOptions: UseMutationOptions<CreateOrderDocumentResponse, CreateOrderDocumentError, Options<CreateOrderDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOrderDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOrderChartsQueryKey = (options: Options<GetOrderChartsData>) => createQueryKey('getOrderCharts', options);

/**
 * Get chart data for an order
 */
export const getOrderChartsOptions = (options: Options<GetOrderChartsData>) => queryOptions<GetOrderChartsResponse, GetOrderChartsError, GetOrderChartsResponse, ReturnType<typeof getOrderChartsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderCharts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderChartsQueryKey(options)
});

/**
 * Replace all chart data for an order
 */
export const updateOrderChartsMutation = (options?: Partial<Options<UpdateOrderChartsData>>): UseMutationOptions<UpdateOrderChartsResponse, UpdateOrderChartsError, Options<UpdateOrderChartsData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrderChartsResponse, UpdateOrderChartsError, Options<UpdateOrderChartsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrderCharts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrderAttachmentsQueryKey = (options: Options<ListOrderAttachmentsData>) => createQueryKey('listOrderAttachments', options);

/**
 * List all file attachments for an order
 */
export const listOrderAttachmentsOptions = (options: Options<ListOrderAttachmentsData>) => queryOptions<ListOrderAttachmentsResponse, DefaultError, ListOrderAttachmentsResponse, ReturnType<typeof listOrderAttachmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrderAttachments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrderAttachmentsQueryKey(options)
});

/**
 * Upload a file attachment to an order
 */
export const uploadOrderAttachmentMutation = (options?: Partial<Options<UploadOrderAttachmentData>>): UseMutationOptions<UploadOrderAttachmentResponse, UploadOrderAttachmentError, Options<UploadOrderAttachmentData>> => {
    const mutationOptions: UseMutationOptions<UploadOrderAttachmentResponse, UploadOrderAttachmentError, Options<UploadOrderAttachmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadOrderAttachment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadOrderAttachmentQueryKey = (options: Options<DownloadOrderAttachmentData>) => createQueryKey('downloadOrderAttachment', options);

/**
 * Download an attachment file
 */
export const downloadOrderAttachmentOptions = (options: Options<DownloadOrderAttachmentData>) => queryOptions<unknown, DownloadOrderAttachmentError, unknown, ReturnType<typeof downloadOrderAttachmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadOrderAttachment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadOrderAttachmentQueryKey(options)
});

export const getCanonicalGraphQueryKey = (options: Options<GetCanonicalGraphData>) => createQueryKey('getCanonicalGraph', options);

/**
 * Get the canonical print-line graph for an order line
 */
export const getCanonicalGraphOptions = (options: Options<GetCanonicalGraphData>) => queryOptions<GetCanonicalGraphResponse, GetCanonicalGraphError, GetCanonicalGraphResponse, ReturnType<typeof getCanonicalGraphQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getCanonicalGraph({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getCanonicalGraphQueryKey(options)
});

export const getMaterializationStatusQueryKey = (options: Options<GetMaterializationStatusData>) => createQueryKey('getMaterializationStatus', options);

/**
 * Get the latest materialization job status for an order line
 */
export const getMaterializationStatusOptions = (options: Options<GetMaterializationStatusData>) => queryOptions<GetMaterializationStatusResponse, GetMaterializationStatusError, GetMaterializationStatusResponse, ReturnType<typeof getMaterializationStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getMaterializationStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getMaterializationStatusQueryKey(options)
});

export const getBatchMaterializationStatusQueryKey = (options: Options<GetBatchMaterializationStatusData>) => createQueryKey('getBatchMaterializationStatus', options);

/**
 * Get materialization job status for all lines in an order
 */
export const getBatchMaterializationStatusOptions = (options: Options<GetBatchMaterializationStatusData>) => queryOptions<GetBatchMaterializationStatusResponse, GetBatchMaterializationStatusError, GetBatchMaterializationStatusResponse, ReturnType<typeof getBatchMaterializationStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getBatchMaterializationStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getBatchMaterializationStatusQueryKey(options)
});

/**
 * Recalculate order totals
 */
export const recalculateOrderTotalsMutation = (options?: Partial<Options<RecalculateOrderTotalsData>>): UseMutationOptions<RecalculateOrderTotalsResponse, RecalculateOrderTotalsError, Options<RecalculateOrderTotalsData>> => {
    const mutationOptions: UseMutationOptions<RecalculateOrderTotalsResponse, RecalculateOrderTotalsError, Options<RecalculateOrderTotalsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await recalculateOrderTotals({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Change order status
 */
export const updateOrderStatusMutation = (options?: Partial<Options<UpdateOrderStatusData>>): UseMutationOptions<UpdateOrderStatusResponse, UpdateOrderStatusError, Options<UpdateOrderStatusData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrderStatusResponse, UpdateOrderStatusError, Options<UpdateOrderStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrderStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update order totals (freight, misc, discount, tax)
 */
export const updateOrderTotalsMutation = (options?: Partial<Options<UpdateOrderTotalsData>>): UseMutationOptions<UpdateOrderTotalsResponse, UpdateOrderTotalsError, Options<UpdateOrderTotalsData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrderTotalsResponse, UpdateOrderTotalsError, Options<UpdateOrderTotalsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrderTotals({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Copy an existing order into a new draft
 */
export const copyOrderMutation = (options?: Partial<Options<CopyOrderData>>): UseMutationOptions<CopyOrderResponse, CopyOrderError, Options<CopyOrderData>> => {
    const mutationOptions: UseMutationOptions<CopyOrderResponse, CopyOrderError, Options<CopyOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await copyOrder({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Override a credit hold on an order (supervisor only)
 */
export const overrideCreditHoldMutation = (options?: Partial<Options<OverrideCreditHoldData>>): UseMutationOptions<OverrideCreditHoldResponse, OverrideCreditHoldError, Options<OverrideCreditHoldData>> => {
    const mutationOptions: UseMutationOptions<OverrideCreditHoldResponse, OverrideCreditHoldError, Options<OverrideCreditHoldData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await overrideCreditHold({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a document/note from an order
 */
export const deleteOrderDocumentMutation = (options?: Partial<Options<DeleteOrderDocumentData>>): UseMutationOptions<DeleteOrderDocumentResponse, DeleteOrderDocumentError, Options<DeleteOrderDocumentData>> => {
    const mutationOptions: UseMutationOptions<DeleteOrderDocumentResponse, DeleteOrderDocumentError, Options<DeleteOrderDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteOrderDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an existing document/note for an order
 */
export const updateOrderDocumentMutation = (options?: Partial<Options<UpdateOrderDocumentData>>): UseMutationOptions<UpdateOrderDocumentResponse, UpdateOrderDocumentError, Options<UpdateOrderDocumentData>> => {
    const mutationOptions: UseMutationOptions<UpdateOrderDocumentResponse, UpdateOrderDocumentError, Options<UpdateOrderDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOrderDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an attachment from an order
 */
export const deleteOrderAttachmentMutation = (options?: Partial<Options<DeleteOrderAttachmentData>>): UseMutationOptions<DeleteOrderAttachmentResponse, DeleteOrderAttachmentError, Options<DeleteOrderAttachmentData>> => {
    const mutationOptions: UseMutationOptions<DeleteOrderAttachmentResponse, DeleteOrderAttachmentError, Options<DeleteOrderAttachmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteOrderAttachment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Trigger print-line materialization for a single order line
 */
export const triggerMaterializationMutation = (options?: Partial<Options<TriggerMaterializationData>>): UseMutationOptions<TriggerMaterializationResponse2, TriggerMaterializationError, Options<TriggerMaterializationData>> => {
    const mutationOptions: UseMutationOptions<TriggerMaterializationResponse2, TriggerMaterializationError, Options<TriggerMaterializationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triggerMaterialization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Trigger print-line materialization for all lines in an order
 */
export const triggerBatchMaterializationMutation = (options?: Partial<Options<TriggerBatchMaterializationData>>): UseMutationOptions<TriggerBatchMaterializationResponse2, TriggerBatchMaterializationError, Options<TriggerBatchMaterializationData>> => {
    const mutationOptions: UseMutationOptions<TriggerBatchMaterializationResponse2, TriggerBatchMaterializationError, Options<TriggerBatchMaterializationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await triggerBatchMaterialization({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listReturnRecallStatusesQueryKey = (options?: Options<ListReturnRecallStatusesData>) => createQueryKey('listReturnRecallStatuses', options);

/**
 * Get all return/recall status codes
 */
export const listReturnRecallStatusesOptions = (options?: Options<ListReturnRecallStatusesData>) => queryOptions<ListReturnRecallStatusesResponse, DefaultError, ListReturnRecallStatusesResponse, ReturnType<typeof listReturnRecallStatusesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listReturnRecallStatuses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listReturnRecallStatusesQueryKey(options)
});

export const listReturnRecallReasonCodesQueryKey = (options?: Options<ListReturnRecallReasonCodesData>) => createQueryKey('listReturnRecallReasonCodes', options);

/**
 * Get all return/recall reason codes
 */
export const listReturnRecallReasonCodesOptions = (options?: Options<ListReturnRecallReasonCodesData>) => queryOptions<ListReturnRecallReasonCodesResponse, DefaultError, ListReturnRecallReasonCodesResponse, ReturnType<typeof listReturnRecallReasonCodesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listReturnRecallReasonCodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listReturnRecallReasonCodesQueryKey(options)
});

export const getReturnRecallQueryKey = (options: Options<GetReturnRecallData>) => createQueryKey('getReturnRecall', options);

/**
 * Get return/recall details for an order
 */
export const getReturnRecallOptions = (options: Options<GetReturnRecallData>) => queryOptions<GetReturnRecallResponse, GetReturnRecallError, GetReturnRecallResponse, ReturnType<typeof getReturnRecallQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getReturnRecall({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getReturnRecallQueryKey(options)
});

/**
 * Create return/recall for an order
 */
export const createReturnRecallMutation = (options?: Partial<Options<CreateReturnRecallData>>): UseMutationOptions<CreateReturnRecallResponse, CreateReturnRecallError, Options<CreateReturnRecallData>> => {
    const mutationOptions: UseMutationOptions<CreateReturnRecallResponse, CreateReturnRecallError, Options<CreateReturnRecallData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createReturnRecall({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update return/recall for an order
 */
export const updateReturnRecallMutation = (options?: Partial<Options<UpdateReturnRecallData>>): UseMutationOptions<UpdateReturnRecallResponse, UpdateReturnRecallError, Options<UpdateReturnRecallData>> => {
    const mutationOptions: UseMutationOptions<UpdateReturnRecallResponse, UpdateReturnRecallError, Options<UpdateReturnRecallData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateReturnRecall({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProductsFilterMetadataQueryKey = (options?: Options<GetProductsFilterMetadataData>) => createQueryKey('getProductsFilterMetadata', options);

/**
 * Get filter metadata for Products list columns
 */
export const getProductsFilterMetadataOptions = (options?: Options<GetProductsFilterMetadataData>) => queryOptions<GetProductsFilterMetadataResponse, DefaultError, GetProductsFilterMetadataResponse, ReturnType<typeof getProductsFilterMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductsFilterMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductsFilterMetadataQueryKey(options)
});

export const listProductsQueryKey = (options?: Options<ListProductsData>) => createQueryKey('listProducts', options);

/**
 * Get paginated list of products
 */
export const listProductsOptions = (options?: Options<ListProductsData>) => queryOptions<ListProductsResponse, DefaultError, ListProductsResponse, ReturnType<typeof listProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProductsQueryKey(options)
});

export const listProductsInfiniteQueryKey = (options?: Options<ListProductsData>): QueryKey<Options<ListProductsData>> => createQueryKey('listProducts', options, true);

/**
 * Get paginated list of products
 */
export const listProductsInfiniteOptions = (options?: Options<ListProductsData>) => infiniteQueryOptions<ListProductsResponse, DefaultError, InfiniteData<ListProductsResponse>, QueryKey<Options<ListProductsData>>, number | string | Pick<QueryKey<Options<ListProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProductsInfiniteQueryKey(options)
});

/**
 * Create a new product
 */
export const createProductMutation = (options?: Partial<Options<CreateProductData>>): UseMutationOptions<CreateProductResponse, CreateProductError, Options<CreateProductData>> => {
    const mutationOptions: UseMutationOptions<CreateProductResponse, CreateProductError, Options<CreateProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listProductUsesQueryKey = (options?: Options<ListProductUsesData>) => createQueryKey('listProductUses', options);

/**
 * Get all product use codes
 */
export const listProductUsesOptions = (options?: Options<ListProductUsesData>) => queryOptions<ListProductUsesResponse, DefaultError, ListProductUsesResponse, ReturnType<typeof listProductUsesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProductUses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProductUsesQueryKey(options)
});

export const listProductTypesQueryKey = (options?: Options<ListProductTypesData>) => createQueryKey('listProductTypes', options);

/**
 * Get all product type codes
 */
export const listProductTypesOptions = (options?: Options<ListProductTypesData>) => queryOptions<ListProductTypesResponse, DefaultError, ListProductTypesResponse, ReturnType<typeof listProductTypesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProductTypes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProductTypesQueryKey(options)
});

export const listProductStatusCodesQueryKey = (options?: Options<ListProductStatusCodesData>) => createQueryKey('listProductStatusCodes', options);

/**
 * Get all product status codes
 */
export const listProductStatusCodesOptions = (options?: Options<ListProductStatusCodesData>) => queryOptions<ListProductStatusCodesResponse, DefaultError, ListProductStatusCodesResponse, ReturnType<typeof listProductStatusCodesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProductStatusCodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProductStatusCodesQueryKey(options)
});

export const searchProductsQueryKey = (options?: Options<SearchProductsData>) => createQueryKey('searchProducts', options);

/**
 * Typeahead search for products
 */
export const searchProductsOptions = (options?: Options<SearchProductsData>) => queryOptions<SearchProductsResponse, DefaultError, SearchProductsResponse, ReturnType<typeof searchProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await searchProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: searchProductsQueryKey(options)
});

export const getProductQueryKey = (options: Options<GetProductData>) => createQueryKey('getProduct', options);

/**
 * Get a single product by ID
 */
export const getProductOptions = (options: Options<GetProductData>) => queryOptions<GetProductResponse, GetProductError, GetProductResponse, ReturnType<typeof getProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductQueryKey(options)
});

/**
 * Update an existing product
 */
export const updateProductMutation = (options?: Partial<Options<UpdateProductData>>): UseMutationOptions<UpdateProductResponse, UpdateProductError, Options<UpdateProductData>> => {
    const mutationOptions: UseMutationOptions<UpdateProductResponse, UpdateProductError, Options<UpdateProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOptionsQueryKey = (options?: Options<ListOptionsData>) => createQueryKey('listOptions', options);

/**
 * Get all options
 */
export const listOptionsOptions = (options?: Options<ListOptionsData>) => queryOptions<ListOptionsResponse, DefaultError, ListOptionsResponse, ReturnType<typeof listOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOptionsQueryKey(options)
});

export const getOptionQueryKey = (options: Options<GetOptionData>) => createQueryKey('getOption', options);

/**
 * Get a single option by ID
 */
export const getOptionOptions = (options: Options<GetOptionData>) => queryOptions<GetOptionResponse, GetOptionError, GetOptionResponse, ReturnType<typeof getOptionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOption({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOptionQueryKey(options)
});

export const listOptionLinksQueryKey = (options: Options<ListOptionLinksData>) => createQueryKey('listOptionLinks', options);

/**
 * Get option links for an option
 */
export const listOptionLinksOptions = (options: Options<ListOptionLinksData>) => queryOptions<ListOptionLinksResponse, DefaultError, ListOptionLinksResponse, ReturnType<typeof listOptionLinksQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOptionLinks({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOptionLinksQueryKey(options)
});

export const listListMastersQueryKey = (options?: Options<ListListMastersData>) => createQueryKey('listListMasters', options);

/**
 * Get all option list masters
 */
export const listListMastersOptions = (options?: Options<ListListMastersData>) => queryOptions<ListListMastersResponse, DefaultError, ListListMastersResponse, ReturnType<typeof listListMastersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listListMasters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listListMastersQueryKey(options)
});

export const listValuesByListQueryKey = (options: Options<ListValuesByListData>) => createQueryKey('listValuesByList', options);

/**
 * Get option values in a specific list
 */
export const listValuesByListOptions = (options: Options<ListValuesByListData>) => queryOptions<ListValuesByListResponse, DefaultError, ListValuesByListResponse, ReturnType<typeof listValuesByListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listValuesByList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listValuesByListQueryKey(options)
});

export const getProductOrderOptionsQueryKey = (options: Options<GetProductOrderOptionsData>) => createQueryKey('getProductOrderOptions', options);

/**
 * Get available product options for order entry
 */
export const getProductOrderOptionsOptions = (options: Options<GetProductOrderOptionsData>) => queryOptions<GetProductOrderOptionsResponse, DefaultError, GetProductOrderOptionsResponse, ReturnType<typeof getProductOrderOptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductOrderOptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductOrderOptionsQueryKey(options)
});

export const listOptionFamiliesQueryKey = (options?: Options<ListOptionFamiliesData>) => createQueryKey('listOptionFamilies', options);

/**
 * Get all option families with their members
 */
export const listOptionFamiliesOptions = (options?: Options<ListOptionFamiliesData>) => queryOptions<ListOptionFamiliesResponse, DefaultError, ListOptionFamiliesResponse, ReturnType<typeof listOptionFamiliesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOptionFamilies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOptionFamiliesQueryKey(options)
});

export const listOptionValuesQueryKey = (options?: Options<ListOptionValuesData>) => createQueryKey('listOptionValues', options);

/**
 * Get paginated list of option values
 */
export const listOptionValuesOptions = (options?: Options<ListOptionValuesData>) => queryOptions<ListOptionValuesResponse, DefaultError, ListOptionValuesResponse, ReturnType<typeof listOptionValuesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOptionValues({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOptionValuesQueryKey(options)
});

export const listOptionValuesInfiniteQueryKey = (options?: Options<ListOptionValuesData>): QueryKey<Options<ListOptionValuesData>> => createQueryKey('listOptionValues', options, true);

/**
 * Get paginated list of option values
 */
export const listOptionValuesInfiniteOptions = (options?: Options<ListOptionValuesData>) => infiniteQueryOptions<ListOptionValuesResponse, DefaultError, InfiniteData<ListOptionValuesResponse>, QueryKey<Options<ListOptionValuesData>>, number | string | Pick<QueryKey<Options<ListOptionValuesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListOptionValuesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listOptionValues({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOptionValuesInfiniteQueryKey(options)
});

/**
 * Create a new option value
 */
export const createOptionValueMutation = (options?: Partial<Options<CreateOptionValueData>>): UseMutationOptions<CreateOptionValueResponse, CreateOptionValueError, Options<CreateOptionValueData>> => {
    const mutationOptions: UseMutationOptions<CreateOptionValueResponse, CreateOptionValueError, Options<CreateOptionValueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createOptionValue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an option value
 */
export const deleteOptionValueMutation = (options?: Partial<Options<DeleteOptionValueData>>): UseMutationOptions<DeleteOptionValueResponse, DeleteOptionValueError, Options<DeleteOptionValueData>> => {
    const mutationOptions: UseMutationOptions<DeleteOptionValueResponse, DeleteOptionValueError, Options<DeleteOptionValueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteOptionValue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getOptionValueQueryKey = (options: Options<GetOptionValueData>) => createQueryKey('getOptionValue', options);

/**
 * Get a single option value by ID
 */
export const getOptionValueOptions = (options: Options<GetOptionValueData>) => queryOptions<GetOptionValueResponse, GetOptionValueError, GetOptionValueResponse, ReturnType<typeof getOptionValueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOptionValue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOptionValueQueryKey(options)
});

/**
 * Update an existing option value
 */
export const updateOptionValueMutation = (options?: Partial<Options<UpdateOptionValueData>>): UseMutationOptions<UpdateOptionValueResponse, UpdateOptionValueError, Options<UpdateOptionValueData>> => {
    const mutationOptions: UseMutationOptions<UpdateOptionValueResponse, UpdateOptionValueError, Options<UpdateOptionValueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateOptionValue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listChargeItemsQueryKey = (options?: Options<ListChargeItemsData>) => createQueryKey('listChargeItems', options);

/**
 * Get paginated list of charge items
 */
export const listChargeItemsOptions = (options?: Options<ListChargeItemsData>) => queryOptions<ListChargeItemsResponse, DefaultError, ListChargeItemsResponse, ReturnType<typeof listChargeItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listChargeItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChargeItemsQueryKey(options)
});

export const listChargeItemsInfiniteQueryKey = (options?: Options<ListChargeItemsData>): QueryKey<Options<ListChargeItemsData>> => createQueryKey('listChargeItems', options, true);

/**
 * Get paginated list of charge items
 */
export const listChargeItemsInfiniteOptions = (options?: Options<ListChargeItemsData>) => infiniteQueryOptions<ListChargeItemsResponse, DefaultError, InfiniteData<ListChargeItemsResponse>, QueryKey<Options<ListChargeItemsData>>, number | string | Pick<QueryKey<Options<ListChargeItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListChargeItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listChargeItems({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChargeItemsInfiniteQueryKey(options)
});

/**
 * Create a new charge item
 */
export const createChargeItemMutation = (options?: Partial<Options<CreateChargeItemData>>): UseMutationOptions<CreateChargeItemResponse, CreateChargeItemError, Options<CreateChargeItemData>> => {
    const mutationOptions: UseMutationOptions<CreateChargeItemResponse, CreateChargeItemError, Options<CreateChargeItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createChargeItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a charge item
 */
export const deleteChargeItemMutation = (options?: Partial<Options<DeleteChargeItemData>>): UseMutationOptions<DeleteChargeItemResponse, DeleteChargeItemError, Options<DeleteChargeItemData>> => {
    const mutationOptions: UseMutationOptions<DeleteChargeItemResponse, DeleteChargeItemError, Options<DeleteChargeItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteChargeItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getChargeItemQueryKey = (options: Options<GetChargeItemData>) => createQueryKey('getChargeItem', options);

/**
 * Get a single charge item by ID
 */
export const getChargeItemOptions = (options: Options<GetChargeItemData>) => queryOptions<GetChargeItemResponse, GetChargeItemError, GetChargeItemResponse, ReturnType<typeof getChargeItemQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChargeItem({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChargeItemQueryKey(options)
});

/**
 * Update an existing charge item
 */
export const updateChargeItemMutation = (options?: Partial<Options<UpdateChargeItemData>>): UseMutationOptions<UpdateChargeItemResponse, UpdateChargeItemError, Options<UpdateChargeItemData>> => {
    const mutationOptions: UseMutationOptions<UpdateChargeItemResponse, UpdateChargeItemError, Options<UpdateChargeItemData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateChargeItem({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview price calculation for a product with options
 */
export const calculatePriceMutation = (options?: Partial<Options<CalculatePriceData>>): UseMutationOptions<CalculatePriceResponse2, DefaultError, Options<CalculatePriceData>> => {
    const mutationOptions: UseMutationOptions<CalculatePriceResponse2, DefaultError, Options<CalculatePriceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await calculatePrice({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPriceHeadersQueryKey = (options: Options<ListPriceHeadersData>) => createQueryKey('listPriceHeaders', options);

/**
 * Get all price headers for a product
 */
export const listPriceHeadersOptions = (options: Options<ListPriceHeadersData>) => queryOptions<ListPriceHeadersResponse, DefaultError, ListPriceHeadersResponse, ReturnType<typeof listPriceHeadersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPriceHeaders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPriceHeadersQueryKey(options)
});

/**
 * Create a new price header for a product
 */
export const createPriceHeaderMutation = (options?: Partial<Options<CreatePriceHeaderData>>): UseMutationOptions<CreatePriceHeaderResponse, CreatePriceHeaderError, Options<CreatePriceHeaderData>> => {
    const mutationOptions: UseMutationOptions<CreatePriceHeaderResponse, CreatePriceHeaderError, Options<CreatePriceHeaderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPriceHeader({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a price header and all its detail lines
 */
export const deletePriceHeaderMutation = (options?: Partial<Options<DeletePriceHeaderData>>): UseMutationOptions<DeletePriceHeaderResponse, DeletePriceHeaderError, Options<DeletePriceHeaderData>> => {
    const mutationOptions: UseMutationOptions<DeletePriceHeaderResponse, DeletePriceHeaderError, Options<DeletePriceHeaderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePriceHeader({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPriceHeaderQueryKey = (options: Options<GetPriceHeaderData>) => createQueryKey('getPriceHeader', options);

/**
 * Get a single price header with detail lines
 */
export const getPriceHeaderOptions = (options: Options<GetPriceHeaderData>) => queryOptions<GetPriceHeaderResponse, GetPriceHeaderError, GetPriceHeaderResponse, ReturnType<typeof getPriceHeaderQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPriceHeader({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPriceHeaderQueryKey(options)
});

/**
 * Update a price header
 */
export const updatePriceHeaderMutation = (options?: Partial<Options<UpdatePriceHeaderData>>): UseMutationOptions<UpdatePriceHeaderResponse, UpdatePriceHeaderError, Options<UpdatePriceHeaderData>> => {
    const mutationOptions: UseMutationOptions<UpdatePriceHeaderResponse, UpdatePriceHeaderError, Options<UpdatePriceHeaderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePriceHeader({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Add a quantity break tier to a price header
 */
export const createPriceDetailMutation = (options?: Partial<Options<CreatePriceDetailData>>): UseMutationOptions<CreatePriceDetailResponse, CreatePriceDetailError, Options<CreatePriceDetailData>> => {
    const mutationOptions: UseMutationOptions<CreatePriceDetailResponse, CreatePriceDetailError, Options<CreatePriceDetailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPriceDetail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a price detail line
 */
export const deletePriceDetailMutation = (options?: Partial<Options<DeletePriceDetailData>>): UseMutationOptions<DeletePriceDetailResponse, DeletePriceDetailError, Options<DeletePriceDetailData>> => {
    const mutationOptions: UseMutationOptions<DeletePriceDetailResponse, DeletePriceDetailError, Options<DeletePriceDetailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePriceDetail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update a price detail line
 */
export const updatePriceDetailMutation = (options?: Partial<Options<UpdatePriceDetailData>>): UseMutationOptions<UpdatePriceDetailResponse, UpdatePriceDetailError, Options<UpdatePriceDetailData>> => {
    const mutationOptions: UseMutationOptions<UpdatePriceDetailResponse, UpdatePriceDetailError, Options<UpdatePriceDetailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePriceDetail({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTextSnippetsQueryKey = (options?: Options<ListTextSnippetsData>) => createQueryKey('listTextSnippets', options);

/**
 * Get all text snippets, optionally filtered by record type
 */
export const listTextSnippetsOptions = (options?: Options<ListTextSnippetsData>) => queryOptions<ListTextSnippetsResponse, DefaultError, ListTextSnippetsResponse, ReturnType<typeof listTextSnippetsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTextSnippets({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTextSnippetsQueryKey(options)
});

/**
 * Create a new text snippet
 */
export const createTextSnippetMutation = (options?: Partial<Options<CreateTextSnippetData>>): UseMutationOptions<CreateTextSnippetResponse, CreateTextSnippetError, Options<CreateTextSnippetData>> => {
    const mutationOptions: UseMutationOptions<CreateTextSnippetResponse, CreateTextSnippetError, Options<CreateTextSnippetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createTextSnippet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a text snippet
 */
export const deleteTextSnippetMutation = (options?: Partial<Options<DeleteTextSnippetData>>): UseMutationOptions<DeleteTextSnippetResponse, DeleteTextSnippetError, Options<DeleteTextSnippetData>> => {
    const mutationOptions: UseMutationOptions<DeleteTextSnippetResponse, DeleteTextSnippetError, Options<DeleteTextSnippetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteTextSnippet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTextSnippetQueryKey = (options: Options<GetTextSnippetData>) => createQueryKey('getTextSnippet', options);

/**
 * Get a text snippet by ID
 */
export const getTextSnippetOptions = (options: Options<GetTextSnippetData>) => queryOptions<GetTextSnippetResponse, GetTextSnippetError, GetTextSnippetResponse, ReturnType<typeof getTextSnippetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTextSnippet({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTextSnippetQueryKey(options)
});

/**
 * Update an existing text snippet
 */
export const updateTextSnippetMutation = (options?: Partial<Options<UpdateTextSnippetData>>): UseMutationOptions<UpdateTextSnippetResponse, UpdateTextSnippetError, Options<UpdateTextSnippetData>> => {
    const mutationOptions: UseMutationOptions<UpdateTextSnippetResponse, UpdateTextSnippetError, Options<UpdateTextSnippetData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateTextSnippet({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listProductSpecsQueryKey = (options?: Options<ListProductSpecsData>) => createQueryKey('listProductSpecs', options);

/**
 * Get a paginated list of product specifications
 */
export const listProductSpecsOptions = (options?: Options<ListProductSpecsData>) => queryOptions<ListProductSpecsResponse, DefaultError, ListProductSpecsResponse, ReturnType<typeof listProductSpecsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listProductSpecs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProductSpecsQueryKey(options)
});

export const listProductSpecsInfiniteQueryKey = (options?: Options<ListProductSpecsData>): QueryKey<Options<ListProductSpecsData>> => createQueryKey('listProductSpecs', options, true);

/**
 * Get a paginated list of product specifications
 */
export const listProductSpecsInfiniteOptions = (options?: Options<ListProductSpecsData>) => infiniteQueryOptions<ListProductSpecsResponse, DefaultError, InfiniteData<ListProductSpecsResponse>, QueryKey<Options<ListProductSpecsData>>, number | string | Pick<QueryKey<Options<ListProductSpecsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListProductSpecsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listProductSpecs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listProductSpecsInfiniteQueryKey(options)
});

/**
 * Create a new product specification
 */
export const createProductSpecMutation = (options?: Partial<Options<CreateProductSpecData>>): UseMutationOptions<CreateProductSpecResponse, CreateProductSpecError, Options<CreateProductSpecData>> => {
    const mutationOptions: UseMutationOptions<CreateProductSpecResponse, CreateProductSpecError, Options<CreateProductSpecData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createProductSpec({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a product specification
 */
export const deleteProductSpecMutation = (options?: Partial<Options<DeleteProductSpecData>>): UseMutationOptions<DeleteProductSpecResponse, DeleteProductSpecError, Options<DeleteProductSpecData>> => {
    const mutationOptions: UseMutationOptions<DeleteProductSpecResponse, DeleteProductSpecError, Options<DeleteProductSpecData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteProductSpec({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getProductSpecQueryKey = (options: Options<GetProductSpecData>) => createQueryKey('getProductSpec', options);

/**
 * Get a product specification by ID
 */
export const getProductSpecOptions = (options: Options<GetProductSpecData>) => queryOptions<GetProductSpecResponse, GetProductSpecError, GetProductSpecResponse, ReturnType<typeof getProductSpecQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductSpec({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductSpecQueryKey(options)
});

/**
 * Update an existing product specification
 */
export const updateProductSpecMutation = (options?: Partial<Options<UpdateProductSpecData>>): UseMutationOptions<UpdateProductSpecResponse, UpdateProductSpecError, Options<UpdateProductSpecData>> => {
    const mutationOptions: UseMutationOptions<UpdateProductSpecResponse, UpdateProductSpecError, Options<UpdateProductSpecData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateProductSpec({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listOrderPaymentsQueryKey = (options: Options<ListOrderPaymentsData>) => createQueryKey('listOrderPayments', options);

/**
 * List payment transactions for an order
 */
export const listOrderPaymentsOptions = (options: Options<ListOrderPaymentsData>) => queryOptions<ListOrderPaymentsResponse, ListOrderPaymentsError, ListOrderPaymentsResponse, ReturnType<typeof listOrderPaymentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrderPayments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrderPaymentsQueryKey(options)
});

export const getHostedPaymentPageQueryKey = (options: Options<GetHostedPaymentPageData>) => createQueryKey('getHostedPaymentPage', options);

/**
 * Get Accept.js hosted payment page token
 */
export const getHostedPaymentPageOptions = (options: Options<GetHostedPaymentPageData>) => queryOptions<GetHostedPaymentPageResponse, GetHostedPaymentPageError, GetHostedPaymentPageResponse, ReturnType<typeof getHostedPaymentPageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getHostedPaymentPage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getHostedPaymentPageQueryKey(options)
});

/**
 * Authorize (hold) a payment without capturing
 */
export const authorizePaymentMutation = (options?: Partial<Options<AuthorizePaymentData>>): UseMutationOptions<AuthorizePaymentResponse, AuthorizePaymentError, Options<AuthorizePaymentData>> => {
    const mutationOptions: UseMutationOptions<AuthorizePaymentResponse, AuthorizePaymentError, Options<AuthorizePaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await authorizePayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Authorize and capture a payment in one step
 */
export const chargePaymentMutation = (options?: Partial<Options<ChargePaymentData>>): UseMutationOptions<ChargePaymentResponse, ChargePaymentError, Options<ChargePaymentData>> => {
    const mutationOptions: UseMutationOptions<ChargePaymentResponse, ChargePaymentError, Options<ChargePaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await chargePayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Capture a previously authorized payment
 */
export const capturePaymentMutation = (options?: Partial<Options<CapturePaymentData>>): UseMutationOptions<CapturePaymentResponse, CapturePaymentError, Options<CapturePaymentData>> => {
    const mutationOptions: UseMutationOptions<CapturePaymentResponse, CapturePaymentError, Options<CapturePaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await capturePayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Void an unsettled transaction
 */
export const voidPaymentMutation = (options?: Partial<Options<VoidPaymentData>>): UseMutationOptions<VoidPaymentResponse, VoidPaymentError, Options<VoidPaymentData>> => {
    const mutationOptions: UseMutationOptions<VoidPaymentResponse, VoidPaymentError, Options<VoidPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await voidPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Refund a settled transaction
 */
export const refundPaymentMutation = (options?: Partial<Options<RefundPaymentData>>): UseMutationOptions<RefundPaymentResponse, RefundPaymentError, Options<RefundPaymentData>> => {
    const mutationOptions: UseMutationOptions<RefundPaymentResponse, RefundPaymentError, Options<RefundPaymentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await refundPayment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPaymentProfilesQueryKey = (options: Options<ListPaymentProfilesData>) => createQueryKey('listPaymentProfiles', options);

/**
 * List saved payment profiles for a customer
 */
export const listPaymentProfilesOptions = (options: Options<ListPaymentProfilesData>) => queryOptions<ListPaymentProfilesResponse, ListPaymentProfilesError, ListPaymentProfilesResponse, ReturnType<typeof listPaymentProfilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPaymentProfiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPaymentProfilesQueryKey(options)
});

/**
 * Save a new payment profile for a customer
 */
export const createPaymentProfileMutation = (options?: Partial<Options<CreatePaymentProfileData>>): UseMutationOptions<CreatePaymentProfileResponse, CreatePaymentProfileError, Options<CreatePaymentProfileData>> => {
    const mutationOptions: UseMutationOptions<CreatePaymentProfileResponse, CreatePaymentProfileError, Options<CreatePaymentProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPaymentProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a saved payment profile
 */
export const deletePaymentProfileMutation = (options?: Partial<Options<DeletePaymentProfileData>>): UseMutationOptions<DeletePaymentProfileResponse, DeletePaymentProfileError, Options<DeletePaymentProfileData>> => {
    const mutationOptions: UseMutationOptions<DeletePaymentProfileResponse, DeletePaymentProfileError, Options<DeletePaymentProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePaymentProfile({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get shipping rate quotes for a destination
 */
export const getShippingRatesMutation = (options?: Partial<Options<GetShippingRatesData>>): UseMutationOptions<GetShippingRatesResponse, GetShippingRatesError, Options<GetShippingRatesData>> => {
    const mutationOptions: UseMutationOptions<GetShippingRatesResponse, GetShippingRatesError, Options<GetShippingRatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getShippingRates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Validate a shipping address via UPS
 */
export const validateShippingAddressMutation = (options?: Partial<Options<ValidateShippingAddressData>>): UseMutationOptions<ValidateShippingAddressResponse, ValidateShippingAddressError, Options<ValidateShippingAddressData>> => {
    const mutationOptions: UseMutationOptions<ValidateShippingAddressResponse, ValidateShippingAddressError, Options<ValidateShippingAddressData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateShippingAddress({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listShippingMethodsQueryKey = (options?: Options<ListShippingMethodsData>) => createQueryKey('listShippingMethods', options);

/**
 * List available shipping methods
 */
export const listShippingMethodsOptions = (options?: Options<ListShippingMethodsData>) => queryOptions<ListShippingMethodsResponse, DefaultError, ListShippingMethodsResponse, ReturnType<typeof listShippingMethodsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listShippingMethods({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listShippingMethodsQueryKey(options)
});

/**
 * Calculate ship-by date based on delivery date and transit time
 */
export const calculateShipDateMutation = (options?: Partial<Options<CalculateShipDateData>>): UseMutationOptions<CalculateShipDateResponse, CalculateShipDateError, Options<CalculateShipDateData>> => {
    const mutationOptions: UseMutationOptions<CalculateShipDateResponse, CalculateShipDateError, Options<CalculateShipDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await calculateShipDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Get live UPS tracking status for a tracking number
 */
export const trackShipmentMutation = (options?: Partial<Options<TrackShipmentData>>): UseMutationOptions<TrackShipmentResponse, TrackShipmentError, Options<TrackShipmentData>> => {
    const mutationOptions: UseMutationOptions<TrackShipmentResponse, TrackShipmentError, Options<TrackShipmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await trackShipment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPackQueueQueryKey = (options?: Options<ListPackQueueData>) => createQueryKey('listPackQueue', options);

/**
 * List orders in INSHIP status ready for packing
 */
export const listPackQueueOptions = (options?: Options<ListPackQueueData>) => queryOptions<ListPackQueueResponse, DefaultError, ListPackQueueResponse, ReturnType<typeof listPackQueueQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPackQueue({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPackQueueQueryKey(options)
});

export const listPackQueueInfiniteQueryKey = (options?: Options<ListPackQueueData>): QueryKey<Options<ListPackQueueData>> => createQueryKey('listPackQueue', options, true);

/**
 * List orders in INSHIP status ready for packing
 */
export const listPackQueueInfiniteOptions = (options?: Options<ListPackQueueData>) => infiniteQueryOptions<ListPackQueueResponse, DefaultError, InfiniteData<ListPackQueueResponse>, QueryKey<Options<ListPackQueueData>>, number | string | Pick<QueryKey<Options<ListPackQueueData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListPackQueueData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listPackQueue({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPackQueueInfiniteQueryKey(options)
});

export const getPackDetailsQueryKey = (options: Options<GetPackDetailsData>) => createQueryKey('getPackDetails', options);

/**
 * Get pack details for an order with line items and carton contents
 */
export const getPackDetailsOptions = (options: Options<GetPackDetailsData>) => queryOptions<GetPackDetailsResponse, GetPackDetailsError, GetPackDetailsResponse, ReturnType<typeof getPackDetailsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPackDetails({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPackDetailsQueryKey(options)
});

/**
 * Remove all carton contents for an order
 */
export const clearCartonsMutation = (options?: Partial<Options<ClearCartonsData>>): UseMutationOptions<ClearCartonsResponse, ClearCartonsError, Options<ClearCartonsData>> => {
    const mutationOptions: UseMutationOptions<ClearCartonsResponse, ClearCartonsError, Options<ClearCartonsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await clearCartons({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create or replace carton contents for an order
 */
export const saveCartonsMutation = (options?: Partial<Options<SaveCartonsData>>): UseMutationOptions<SaveCartonsResponse, SaveCartonsError, Options<SaveCartonsData>> => {
    const mutationOptions: UseMutationOptions<SaveCartonsResponse, SaveCartonsError, Options<SaveCartonsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await saveCartons({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Generate WorldShip-compatible tab-delimited export file from INSHIP orders
 */
export const exportWorldShipMutation = (options?: Partial<Options<ExportWorldShipData>>): UseMutationOptions<ExportWorldShipResponse, ExportWorldShipError, Options<ExportWorldShipData>> => {
    const mutationOptions: UseMutationOptions<ExportWorldShipResponse, ExportWorldShipError, Options<ExportWorldShipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await exportWorldShip({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorldShipExportLogQueryKey = (options?: Options<ListWorldShipExportLogData>) => createQueryKey('listWorldShipExportLog', options);

/**
 * List WorldShip export log entries with pagination
 */
export const listWorldShipExportLogOptions = (options?: Options<ListWorldShipExportLogData>) => queryOptions<ListWorldShipExportLogResponse, DefaultError, ListWorldShipExportLogResponse, ReturnType<typeof listWorldShipExportLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorldShipExportLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorldShipExportLogQueryKey(options)
});

export const listWorldShipExportLogInfiniteQueryKey = (options?: Options<ListWorldShipExportLogData>): QueryKey<Options<ListWorldShipExportLogData>> => createQueryKey('listWorldShipExportLog', options, true);

/**
 * List WorldShip export log entries with pagination
 */
export const listWorldShipExportLogInfiniteOptions = (options?: Options<ListWorldShipExportLogData>) => infiniteQueryOptions<ListWorldShipExportLogResponse, DefaultError, InfiniteData<ListWorldShipExportLogResponse>, QueryKey<Options<ListWorldShipExportLogData>>, number | string | Pick<QueryKey<Options<ListWorldShipExportLogData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListWorldShipExportLogData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listWorldShipExportLog({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorldShipExportLogInfiniteQueryKey(options)
});

/**
 * Upload and process a WorldShip return CSV file
 */
export const importWorldShipMutation = (options?: Partial<Options<ImportWorldShipData>>): UseMutationOptions<ImportWorldShipResponse, ImportWorldShipError, Options<ImportWorldShipData>> => {
    const mutationOptions: UseMutationOptions<ImportWorldShipResponse, ImportWorldShipError, Options<ImportWorldShipData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await importWorldShip({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Preview a WorldShip CSV import without writing data
 */
export const previewWorldShipImportMutation = (options?: Partial<Options<PreviewWorldShipImportData>>): UseMutationOptions<PreviewWorldShipImportResponse, PreviewWorldShipImportError, Options<PreviewWorldShipImportData>> => {
    const mutationOptions: UseMutationOptions<PreviewWorldShipImportResponse, PreviewWorldShipImportError, Options<PreviewWorldShipImportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await previewWorldShipImport({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listWorldShipImportLogQueryKey = (options?: Options<ListWorldShipImportLogData>) => createQueryKey('listWorldShipImportLog', options);

/**
 * List WorldShip import processing log entries
 */
export const listWorldShipImportLogOptions = (options?: Options<ListWorldShipImportLogData>) => queryOptions<ListWorldShipImportLogResponse, DefaultError, ListWorldShipImportLogResponse, ReturnType<typeof listWorldShipImportLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listWorldShipImportLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorldShipImportLogQueryKey(options)
});

export const listWorldShipImportLogInfiniteQueryKey = (options?: Options<ListWorldShipImportLogData>): QueryKey<Options<ListWorldShipImportLogData>> => createQueryKey('listWorldShipImportLog', options, true);

/**
 * List WorldShip import processing log entries
 */
export const listWorldShipImportLogInfiniteOptions = (options?: Options<ListWorldShipImportLogData>) => infiniteQueryOptions<ListWorldShipImportLogResponse, DefaultError, InfiniteData<ListWorldShipImportLogResponse>, QueryKey<Options<ListWorldShipImportLogData>>, number | string | Pick<QueryKey<Options<ListWorldShipImportLogData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListWorldShipImportLogData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listWorldShipImportLog({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listWorldShipImportLogInfiniteQueryKey(options)
});

export const listOrderShipmentsQueryKey = (options: Options<ListOrderShipmentsData>) => createQueryKey('listOrderShipments', options);

/**
 * List shipment packages for an order
 */
export const listOrderShipmentsOptions = (options: Options<ListOrderShipmentsData>) => queryOptions<ListOrderShipmentsResponse, ListOrderShipmentsError, ListOrderShipmentsResponse, ReturnType<typeof listOrderShipmentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listOrderShipments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listOrderShipmentsQueryKey(options)
});

/**
 * Create a UPS shipment via API for an order
 */
export const createShipmentMutation = (options?: Partial<Options<CreateShipmentData>>): UseMutationOptions<CreateShipmentResponse2, CreateShipmentError, Options<CreateShipmentData>> => {
    const mutationOptions: UseMutationOptions<CreateShipmentResponse2, CreateShipmentError, Options<CreateShipmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createShipment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Void a shipment package
 */
export const voidShipmentMutation = (options?: Partial<Options<VoidShipmentData>>): UseMutationOptions<VoidShipmentResponse, VoidShipmentError, Options<VoidShipmentData>> => {
    const mutationOptions: UseMutationOptions<VoidShipmentResponse, VoidShipmentError, Options<VoidShipmentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await voidShipment({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getShipmentLabelQueryKey = (options: Options<GetShipmentLabelData>) => createQueryKey('getShipmentLabel', options);

/**
 * Download the shipping label for a package
 */
export const getShipmentLabelOptions = (options: Options<GetShipmentLabelData>) => queryOptions<GetShipmentLabelResponse, GetShipmentLabelError, GetShipmentLabelResponse, ReturnType<typeof getShipmentLabelQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getShipmentLabel({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getShipmentLabelQueryKey(options)
});

export const getDashboardSummaryQueryKey = (options?: Options<GetDashboardSummaryData>) => createQueryKey('getDashboardSummary', options);

/**
 * Get aggregated KPI metrics for the landing page dashboard
 */
export const getDashboardSummaryOptions = (options?: Options<GetDashboardSummaryData>) => queryOptions<GetDashboardSummaryResponse, DefaultError, GetDashboardSummaryResponse, ReturnType<typeof getDashboardSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDashboardSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDashboardSummaryQueryKey(options)
});

export const getOrdersByStatusQueryKey = (options?: Options<GetOrdersByStatusData>) => createQueryKey('getOrdersByStatus', options);

/**
 * Get order counts grouped by status for the dashboard bar chart
 */
export const getOrdersByStatusOptions = (options?: Options<GetOrdersByStatusData>) => queryOptions<GetOrdersByStatusResponse, DefaultError, GetOrdersByStatusResponse, ReturnType<typeof getOrdersByStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrdersByStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrdersByStatusQueryKey(options)
});

export const getOrderStatusHistoryQueryKey = (options?: Options<GetOrderStatusHistoryData>) => createQueryKey('getOrderStatusHistory', options);

/**
 * Get order counts grouped by status over time for the dashboard trend line chart
 */
export const getOrderStatusHistoryOptions = (options?: Options<GetOrderStatusHistoryData>) => queryOptions<GetOrderStatusHistoryResponse, DefaultError, GetOrderStatusHistoryResponse, ReturnType<typeof getOrderStatusHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrderStatusHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrderStatusHistoryQueryKey(options)
});

export const getRecentActivityQueryKey = (options?: Options<GetRecentActivityData>) => createQueryKey('getRecentActivity', options);

/**
 * Get recent change log entries for the dashboard activity feed
 */
export const getRecentActivityOptions = (options?: Options<GetRecentActivityData>) => queryOptions<GetRecentActivityResponse, DefaultError, GetRecentActivityResponse, ReturnType<typeof getRecentActivityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRecentActivity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRecentActivityQueryKey(options)
});

export const getOrdersByMonthQueryKey = (options?: Options<GetOrdersByMonthData>) => createQueryKey('getOrdersByMonth', options);

/**
 * Get order counts bucketed by time period for the dashboard line chart
 */
export const getOrdersByMonthOptions = (options?: Options<GetOrdersByMonthData>) => queryOptions<GetOrdersByMonthResponse, DefaultError, GetOrdersByMonthResponse, ReturnType<typeof getOrdersByMonthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrdersByMonth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrdersByMonthQueryKey(options)
});

export const getRevenueByMonthQueryKey = (options?: Options<GetRevenueByMonthData>) => createQueryKey('getRevenueByMonth', options);

/**
 * Get revenue totals bucketed by time period for the dashboard line chart
 */
export const getRevenueByMonthOptions = (options?: Options<GetRevenueByMonthData>) => queryOptions<GetRevenueByMonthResponse, DefaultError, GetRevenueByMonthResponse, ReturnType<typeof getRevenueByMonthQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getRevenueByMonth({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getRevenueByMonthQueryKey(options)
});

export const getTopCustomersQueryKey = (options?: Options<GetTopCustomersData>) => createQueryKey('getTopCustomers', options);

/**
 * Get top customers ranked by revenue for the dashboard bar chart
 */
export const getTopCustomersOptions = (options?: Options<GetTopCustomersData>) => queryOptions<GetTopCustomersResponse, DefaultError, GetTopCustomersResponse, ReturnType<typeof getTopCustomersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTopCustomers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTopCustomersQueryKey(options)
});

export const getProductionBacklogQueryKey = (options?: Options<GetProductionBacklogData>) => createQueryKey('getProductionBacklog', options);

/**
 * Get production and artwork queue metrics for the production dashboard
 */
export const getProductionBacklogOptions = (options?: Options<GetProductionBacklogData>) => queryOptions<GetProductionBacklogResponse, DefaultError, GetProductionBacklogResponse, ReturnType<typeof getProductionBacklogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getProductionBacklog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getProductionBacklogQueryKey(options)
});

export const getOrdersByDivisionQueryKey = (options?: Options<GetOrdersByDivisionData>) => createQueryKey('getOrdersByDivision', options);

/**
 * Get order counts grouped by division for the dashboard pie chart
 */
export const getOrdersByDivisionOptions = (options?: Options<GetOrdersByDivisionData>) => queryOptions<GetOrdersByDivisionResponse, DefaultError, GetOrdersByDivisionResponse, ReturnType<typeof getOrdersByDivisionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrdersByDivision({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrdersByDivisionQueryKey(options)
});

export const getTopSalesRepsQueryKey = (options?: Options<GetTopSalesRepsData>) => createQueryKey('getTopSalesReps', options);

/**
 * Get top sales representatives ranked by order count for the dashboard bar chart
 */
export const getTopSalesRepsOptions = (options?: Options<GetTopSalesRepsData>) => queryOptions<GetTopSalesRepsResponse, DefaultError, GetTopSalesRepsResponse, ReturnType<typeof getTopSalesRepsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTopSalesReps({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTopSalesRepsQueryKey(options)
});

export const getOrdersByManufacturingLocationQueryKey = (options?: Options<GetOrdersByManufacturingLocationData>) => createQueryKey('getOrdersByManufacturingLocation', options);

/**
 * Get order counts grouped by manufacturing location for the manufacturing dashboard
 */
export const getOrdersByManufacturingLocationOptions = (options?: Options<GetOrdersByManufacturingLocationData>) => queryOptions<GetOrdersByManufacturingLocationResponse, DefaultError, GetOrdersByManufacturingLocationResponse, ReturnType<typeof getOrdersByManufacturingLocationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getOrdersByManufacturingLocation({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getOrdersByManufacturingLocationQueryKey(options)
});

export const generateInvoiceQueryKey = (options: Options<GenerateInvoiceData>) => createQueryKey('generateInvoice', options);

/**
 * Generate a PDF invoice for an order
 */
export const generateInvoiceOptions = (options: Options<GenerateInvoiceData>) => queryOptions<unknown, GenerateInvoiceError, unknown, ReturnType<typeof generateInvoiceQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generateInvoice({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generateInvoiceQueryKey(options)
});

export const generateGoldenrodQueryKey = (options: Options<GenerateGoldenrodData>) => createQueryKey('generateGoldenrod', options);

/**
 * Generate a goldenrod production ticket PDF for an order
 */
export const generateGoldenrodOptions = (options: Options<GenerateGoldenrodData>) => queryOptions<unknown, GenerateGoldenrodError, unknown, ReturnType<typeof generateGoldenrodQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generateGoldenrod({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generateGoldenrodQueryKey(options)
});

export const generatePackingListQueryKey = (options: Options<GeneratePackingListData>) => createQueryKey('generatePackingList', options);

/**
 * Generate a packing list PDF for an order
 */
export const generatePackingListOptions = (options: Options<GeneratePackingListData>) => queryOptions<unknown, GeneratePackingListError, unknown, ReturnType<typeof generatePackingListQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generatePackingList({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generatePackingListQueryKey(options)
});

export const generateRecallFormQueryKey = (options: Options<GenerateRecallFormData>) => createQueryKey('generateRecallForm', options);

/**
 * Generate a recall form PDF for an order
 */
export const generateRecallFormOptions = (options: Options<GenerateRecallFormData>) => queryOptions<unknown, GenerateRecallFormError, unknown, ReturnType<typeof generateRecallFormQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generateRecallForm({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generateRecallFormQueryKey(options)
});

export const generateReturnFormQueryKey = (options: Options<GenerateReturnFormData>) => createQueryKey('generateReturnForm', options);

/**
 * Generate a return form PDF for an order
 */
export const generateReturnFormOptions = (options: Options<GenerateReturnFormData>) => queryOptions<unknown, GenerateReturnFormError, unknown, ReturnType<typeof generateReturnFormQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generateReturnForm({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generateReturnFormQueryKey(options)
});

export const generateAcknowledgmentQueryKey = (options: Options<GenerateAcknowledgmentData>) => createQueryKey('generateAcknowledgment', options);

/**
 * Generate an acknowledgment PDF for an order using a template
 */
export const generateAcknowledgmentOptions = (options: Options<GenerateAcknowledgmentData>) => queryOptions<unknown, GenerateAcknowledgmentError, unknown, ReturnType<typeof generateAcknowledgmentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generateAcknowledgment({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generateAcknowledgmentQueryKey(options)
});

export const generateArtworkRequestFormQueryKey = (options: Options<GenerateArtworkRequestFormData>) => createQueryKey('generateArtworkRequestForm', options);

/**
 * Generate an artwork request form PDF
 */
export const generateArtworkRequestFormOptions = (options: Options<GenerateArtworkRequestFormData>) => queryOptions<unknown, GenerateArtworkRequestFormError, unknown, ReturnType<typeof generateArtworkRequestFormQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await generateArtworkRequestForm({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: generateArtworkRequestFormQueryKey(options)
});

export const exportOrdersQueryKey = (options: Options<ExportOrdersData>) => createQueryKey('exportOrders', options);

/**
 * Export filtered orders to Excel
 */
export const exportOrdersOptions = (options: Options<ExportOrdersData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof exportOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportOrdersQueryKey(options)
});

export const exportCustomersQueryKey = (options: Options<ExportCustomersData>) => createQueryKey('exportCustomers', options);

/**
 * Export filtered customers to Excel
 */
export const exportCustomersOptions = (options: Options<ExportCustomersData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof exportCustomersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportCustomers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportCustomersQueryKey(options)
});

export const exportProductsQueryKey = (options: Options<ExportProductsData>) => createQueryKey('exportProducts', options);

/**
 * Export filtered products to Excel
 */
export const exportProductsOptions = (options: Options<ExportProductsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof exportProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportProductsQueryKey(options)
});

export const exportDesignsQueryKey = (options: Options<ExportDesignsData>) => createQueryKey('exportDesigns', options);

/**
 * Export filtered designs to Excel
 */
export const exportDesignsOptions = (options: Options<ExportDesignsData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof exportDesignsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await exportDesigns({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: exportDesignsQueryKey(options)
});

export const getApiReportsGeneratedQueryKey = (options?: Options<GetApiReportsGeneratedData>) => createQueryKey('getApiReportsGenerated', options);

/**
 * List generated reports for the current user
 */
export const getApiReportsGeneratedOptions = (options?: Options<GetApiReportsGeneratedData>) => queryOptions<GetApiReportsGeneratedResponse, DefaultError, GetApiReportsGeneratedResponse, ReturnType<typeof getApiReportsGeneratedQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiReportsGenerated({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiReportsGeneratedQueryKey(options)
});

/**
 * Queue a new report for background generation
 */
export const postApiReportsGeneratedMutation = (options?: Partial<Options<PostApiReportsGeneratedData>>): UseMutationOptions<PostApiReportsGeneratedResponse, DefaultError, Options<PostApiReportsGeneratedData>> => {
    const mutationOptions: UseMutationOptions<PostApiReportsGeneratedResponse, DefaultError, Options<PostApiReportsGeneratedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postApiReportsGenerated({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiReportsGeneratedByIdDownloadQueryKey = (options: Options<GetApiReportsGeneratedByIdDownloadData>) => createQueryKey('getApiReportsGeneratedByIdDownload', options);

/**
 * Download a completed generated report
 */
export const getApiReportsGeneratedByIdDownloadOptions = (options: Options<GetApiReportsGeneratedByIdDownloadData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getApiReportsGeneratedByIdDownloadQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiReportsGeneratedByIdDownload({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiReportsGeneratedByIdDownloadQueryKey(options)
});

/**
 * Enqueue an order confirmation email for background sending
 */
export const sendOrderConfirmationAsyncMutation = (options?: Partial<Options<SendOrderConfirmationAsyncData>>): UseMutationOptions<unknown, DefaultError, Options<SendOrderConfirmationAsyncData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SendOrderConfirmationAsyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendOrderConfirmationAsync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send an order confirmation email synchronously
 */
export const sendOrderConfirmationSyncMutation = (options?: Partial<Options<SendOrderConfirmationSyncData>>): UseMutationOptions<SendOrderConfirmationSyncResponse, SendOrderConfirmationSyncError, Options<SendOrderConfirmationSyncData>> => {
    const mutationOptions: UseMutationOptions<SendOrderConfirmationSyncResponse, SendOrderConfirmationSyncError, Options<SendOrderConfirmationSyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendOrderConfirmationSync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue an invoice email for background sending
 */
export const sendInvoiceEmailAsyncMutation = (options?: Partial<Options<SendInvoiceEmailAsyncData>>): UseMutationOptions<unknown, DefaultError, Options<SendInvoiceEmailAsyncData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SendInvoiceEmailAsyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendInvoiceEmailAsync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send an invoice email synchronously
 */
export const sendInvoiceEmailSyncMutation = (options?: Partial<Options<SendInvoiceEmailSyncData>>): UseMutationOptions<SendInvoiceEmailSyncResponse, SendInvoiceEmailSyncError, Options<SendInvoiceEmailSyncData>> => {
    const mutationOptions: UseMutationOptions<SendInvoiceEmailSyncResponse, SendInvoiceEmailSyncError, Options<SendInvoiceEmailSyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendInvoiceEmailSync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Enqueue a shipping notification email for background sending
 */
export const sendShippingNotificationAsyncMutation = (options?: Partial<Options<SendShippingNotificationAsyncData>>): UseMutationOptions<unknown, DefaultError, Options<SendShippingNotificationAsyncData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SendShippingNotificationAsyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendShippingNotificationAsync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Send a shipping notification email synchronously
 */
export const sendShippingNotificationSyncMutation = (options?: Partial<Options<SendShippingNotificationSyncData>>): UseMutationOptions<SendShippingNotificationSyncResponse, SendShippingNotificationSyncError, Options<SendShippingNotificationSyncData>> => {
    const mutationOptions: UseMutationOptions<SendShippingNotificationSyncResponse, SendShippingNotificationSyncError, Options<SendShippingNotificationSyncData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await sendShippingNotificationSync({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getEmailLogQueryKey = (options?: Options<GetEmailLogData>) => createQueryKey('getEmailLog', options);

/**
 * Get paginated email log entries
 */
export const getEmailLogOptions = (options?: Options<GetEmailLogData>) => queryOptions<GetEmailLogResponse, DefaultError, GetEmailLogResponse, ReturnType<typeof getEmailLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmailLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmailLogQueryKey(options)
});

export const getEmailLogInfiniteQueryKey = (options?: Options<GetEmailLogData>): QueryKey<Options<GetEmailLogData>> => createQueryKey('getEmailLog', options, true);

/**
 * Get paginated email log entries
 */
export const getEmailLogInfiniteOptions = (options?: Options<GetEmailLogData>) => infiniteQueryOptions<GetEmailLogResponse, DefaultError, InfiniteData<GetEmailLogResponse>, QueryKey<Options<GetEmailLogData>>, number | string | Pick<QueryKey<Options<GetEmailLogData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetEmailLogData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getEmailLog({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmailLogInfiniteQueryKey(options)
});

export const getEmailLogDetailQueryKey = (options: Options<GetEmailLogDetailData>) => createQueryKey('getEmailLogDetail', options);

/**
 * Get a single email log entry with full details including HTML body
 */
export const getEmailLogDetailOptions = (options: Options<GetEmailLogDetailData>) => queryOptions<GetEmailLogDetailResponse, GetEmailLogDetailError, GetEmailLogDetailResponse, ReturnType<typeof getEmailLogDetailQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmailLogDetail({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmailLogDetailQueryKey(options)
});

export const getEmailSettingsQueryKey = (options?: Options<GetEmailSettingsData>) => createQueryKey('getEmailSettings', options);

/**
 * List all email settings
 */
export const getEmailSettingsOptions = (options?: Options<GetEmailSettingsData>) => queryOptions<GetEmailSettingsResponse, DefaultError, GetEmailSettingsResponse, ReturnType<typeof getEmailSettingsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmailSettings({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmailSettingsQueryKey(options)
});

export const getEmailSettingQueryKey = (options: Options<GetEmailSettingData>) => createQueryKey('getEmailSetting', options);

/**
 * Get a single email setting by ID
 */
export const getEmailSettingOptions = (options: Options<GetEmailSettingData>) => queryOptions<GetEmailSettingResponse, GetEmailSettingError, GetEmailSettingResponse, ReturnType<typeof getEmailSettingQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getEmailSetting({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getEmailSettingQueryKey(options)
});

/**
 * Update an email setting
 */
export const updateEmailSettingMutation = (options?: Partial<Options<UpdateEmailSettingData>>): UseMutationOptions<UpdateEmailSettingResponse, UpdateEmailSettingError, Options<UpdateEmailSettingData>> => {
    const mutationOptions: UseMutationOptions<UpdateEmailSettingResponse, UpdateEmailSettingError, Options<UpdateEmailSettingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateEmailSetting({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const previewEmailTemplateQueryKey = (options: Options<PreviewEmailTemplateData>) => createQueryKey('previewEmailTemplate', options);

/**
 * Render an email template with sample data for preview
 */
export const previewEmailTemplateOptions = (options: Options<PreviewEmailTemplateData>) => queryOptions<PreviewEmailTemplateResponse, PreviewEmailTemplateError, PreviewEmailTemplateResponse, ReturnType<typeof previewEmailTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await previewEmailTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: previewEmailTemplateQueryKey(options)
});

export const getArtworkRequestsFilterMetadataQueryKey = (options?: Options<GetArtworkRequestsFilterMetadataData>) => createQueryKey('getArtworkRequestsFilterMetadata', options);

/**
 * Get filter metadata for ArtworkRequests list columns
 */
export const getArtworkRequestsFilterMetadataOptions = (options?: Options<GetArtworkRequestsFilterMetadataData>) => queryOptions<GetArtworkRequestsFilterMetadataResponse, DefaultError, GetArtworkRequestsFilterMetadataResponse, ReturnType<typeof getArtworkRequestsFilterMetadataQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getArtworkRequestsFilterMetadata({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getArtworkRequestsFilterMetadataQueryKey(options)
});

export const listArtworkRequestsQueryKey = (options?: Options<ListArtworkRequestsData>) => createQueryKey('listArtworkRequests', options);

/**
 * Get paginated list of artwork requests
 */
export const listArtworkRequestsOptions = (options?: Options<ListArtworkRequestsData>) => queryOptions<ListArtworkRequestsResponse, DefaultError, ListArtworkRequestsResponse, ReturnType<typeof listArtworkRequestsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listArtworkRequests({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listArtworkRequestsQueryKey(options)
});

export const listArtworkRequestsInfiniteQueryKey = (options?: Options<ListArtworkRequestsData>): QueryKey<Options<ListArtworkRequestsData>> => createQueryKey('listArtworkRequests', options, true);

/**
 * Get paginated list of artwork requests
 */
export const listArtworkRequestsInfiniteOptions = (options?: Options<ListArtworkRequestsData>) => infiniteQueryOptions<ListArtworkRequestsResponse, DefaultError, InfiniteData<ListArtworkRequestsResponse>, QueryKey<Options<ListArtworkRequestsData>>, number | string | Pick<QueryKey<Options<ListArtworkRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListArtworkRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listArtworkRequests({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listArtworkRequestsInfiniteQueryKey(options)
});

/**
 * Create a new artwork request for an order
 */
export const createArtworkRequestMutation = (options?: Partial<Options<CreateArtworkRequestData>>): UseMutationOptions<CreateArtworkRequestResponse, CreateArtworkRequestError, Options<CreateArtworkRequestData>> => {
    const mutationOptions: UseMutationOptions<CreateArtworkRequestResponse, CreateArtworkRequestError, Options<CreateArtworkRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createArtworkRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listArtistsQueryKey = (options?: Options<ListArtistsData>) => createQueryKey('listArtists', options);

/**
 * Get art-eligible users from Art1 and Creative1 access groups
 */
export const listArtistsOptions = (options?: Options<ListArtistsData>) => queryOptions<ListArtistsResponse, DefaultError, ListArtistsResponse, ReturnType<typeof listArtistsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listArtists({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listArtistsQueryKey(options)
});

export const listArtworkStatusCodesQueryKey = (options?: Options<ListArtworkStatusCodesData>) => createQueryKey('listArtworkStatusCodes', options);

/**
 * Get all artwork status codes ordered by sequence
 */
export const listArtworkStatusCodesOptions = (options?: Options<ListArtworkStatusCodesData>) => queryOptions<ListArtworkStatusCodesResponse, DefaultError, ListArtworkStatusCodesResponse, ReturnType<typeof listArtworkStatusCodesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listArtworkStatusCodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listArtworkStatusCodesQueryKey(options)
});

export const getArtworkRequestQueryKey = (options: Options<GetArtworkRequestData>) => createQueryKey('getArtworkRequest', options);

/**
 * Get a single artwork request by ID
 */
export const getArtworkRequestOptions = (options: Options<GetArtworkRequestData>) => queryOptions<GetArtworkRequestResponse, GetArtworkRequestError, GetArtworkRequestResponse, ReturnType<typeof getArtworkRequestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getArtworkRequest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getArtworkRequestQueryKey(options)
});

/**
 * Update an existing artwork request
 */
export const updateArtworkRequestMutation = (options?: Partial<Options<UpdateArtworkRequestData>>): UseMutationOptions<UpdateArtworkRequestResponse, UpdateArtworkRequestError, Options<UpdateArtworkRequestData>> => {
    const mutationOptions: UseMutationOptions<UpdateArtworkRequestResponse, UpdateArtworkRequestError, Options<UpdateArtworkRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateArtworkRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listArtworkStatusHistoryQueryKey = (options: Options<ListArtworkStatusHistoryData>) => createQueryKey('listArtworkStatusHistory', options);

/**
 * Get status update history for an artwork request
 */
export const listArtworkStatusHistoryOptions = (options: Options<ListArtworkStatusHistoryData>) => queryOptions<ListArtworkStatusHistoryResponse, ListArtworkStatusHistoryError, ListArtworkStatusHistoryResponse, ReturnType<typeof listArtworkStatusHistoryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listArtworkStatusHistory({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listArtworkStatusHistoryQueryKey(options)
});

export const listArtworkRequestImagesQueryKey = (options: Options<ListArtworkRequestImagesData>) => createQueryKey('listArtworkRequestImages', options);

/**
 * Get additional images for an artwork request
 */
export const listArtworkRequestImagesOptions = (options: Options<ListArtworkRequestImagesData>) => queryOptions<ListArtworkRequestImagesResponse, ListArtworkRequestImagesError, ListArtworkRequestImagesResponse, ReturnType<typeof listArtworkRequestImagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listArtworkRequestImages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listArtworkRequestImagesQueryKey(options)
});

/**
 * Upload an additional detail image for an artwork request
 */
export const uploadArtworkRequestImageMutation = (options?: Partial<Options<UploadArtworkRequestImageData>>): UseMutationOptions<UploadArtworkRequestImageResponse, UploadArtworkRequestImageError, Options<UploadArtworkRequestImageData>> => {
    const mutationOptions: UseMutationOptions<UploadArtworkRequestImageResponse, UploadArtworkRequestImageError, Options<UploadArtworkRequestImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await uploadArtworkRequestImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const downloadArtworkRequestImageQueryKey = (options: Options<DownloadArtworkRequestImageData>) => createQueryKey('downloadArtworkRequestImage', options);

/**
 * Download an artwork request image file
 */
export const downloadArtworkRequestImageOptions = (options: Options<DownloadArtworkRequestImageData>) => queryOptions<unknown, DownloadArtworkRequestImageError, unknown, ReturnType<typeof downloadArtworkRequestImageQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await downloadArtworkRequestImage({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: downloadArtworkRequestImageQueryKey(options)
});

/**
 * Add a status update to an artwork request
 */
export const updateArtworkStatusMutation = (options?: Partial<Options<UpdateArtworkStatusData>>): UseMutationOptions<UpdateArtworkStatusResponse, UpdateArtworkStatusError, Options<UpdateArtworkStatusData>> => {
    const mutationOptions: UseMutationOptions<UpdateArtworkStatusResponse, UpdateArtworkStatusError, Options<UpdateArtworkStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateArtworkStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Assign or unassign an artist to an artwork request
 */
export const assignArtistMutation = (options?: Partial<Options<AssignArtistData>>): UseMutationOptions<AssignArtistResponse, AssignArtistError, Options<AssignArtistData>> => {
    const mutationOptions: UseMutationOptions<AssignArtistResponse, AssignArtistError, Options<AssignArtistData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await assignArtist({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Mark an artwork request as complete with completion details
 */
export const completeArtworkRequestMutation = (options?: Partial<Options<CompleteArtworkRequestData>>): UseMutationOptions<CompleteArtworkRequestResponse, CompleteArtworkRequestError, Options<CompleteArtworkRequestData>> => {
    const mutationOptions: UseMutationOptions<CompleteArtworkRequestResponse, CompleteArtworkRequestError, Options<CompleteArtworkRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await completeArtworkRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an additional detail image from an artwork request
 */
export const deleteArtworkRequestImageMutation = (options?: Partial<Options<DeleteArtworkRequestImageData>>): UseMutationOptions<DeleteArtworkRequestImageResponse, DeleteArtworkRequestImageError, Options<DeleteArtworkRequestImageData>> => {
    const mutationOptions: UseMutationOptions<DeleteArtworkRequestImageResponse, DeleteArtworkRequestImageError, Options<DeleteArtworkRequestImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteArtworkRequestImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Dispatch a document to a FolderMill printer
 */
export const printOrderDocumentMutation = (options?: Partial<Options<PrintOrderDocumentData>>): UseMutationOptions<PrintOrderDocumentResponse, PrintOrderDocumentError, Options<PrintOrderDocumentData>> => {
    const mutationOptions: UseMutationOptions<PrintOrderDocumentResponse, PrintOrderDocumentError, Options<PrintOrderDocumentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await printOrderDocument({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Quick print acknowledgment to default printer without preview
 */
export const quickPrintMutation = (options?: Partial<Options<QuickPrintData>>): UseMutationOptions<QuickPrintResponse, QuickPrintError, Options<QuickPrintData>> => {
    const mutationOptions: UseMutationOptions<QuickPrintResponse, QuickPrintError, Options<QuickPrintData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await quickPrint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listInvoiceEligibleOrdersQueryKey = (options?: Options<ListInvoiceEligibleOrdersData>) => createQueryKey('listInvoiceEligibleOrders', options);

/**
 * List orders eligible for invoice transmission
 */
export const listInvoiceEligibleOrdersOptions = (options?: Options<ListInvoiceEligibleOrdersData>) => queryOptions<ListInvoiceEligibleOrdersResponse, DefaultError, ListInvoiceEligibleOrdersResponse, ReturnType<typeof listInvoiceEligibleOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listInvoiceEligibleOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInvoiceEligibleOrdersQueryKey(options)
});

export const listInvoiceEligibleOrdersInfiniteQueryKey = (options?: Options<ListInvoiceEligibleOrdersData>): QueryKey<Options<ListInvoiceEligibleOrdersData>> => createQueryKey('listInvoiceEligibleOrders', options, true);

/**
 * List orders eligible for invoice transmission
 */
export const listInvoiceEligibleOrdersInfiniteOptions = (options?: Options<ListInvoiceEligibleOrdersData>) => infiniteQueryOptions<ListInvoiceEligibleOrdersResponse, DefaultError, InfiniteData<ListInvoiceEligibleOrdersResponse>, QueryKey<Options<ListInvoiceEligibleOrdersData>>, number | string | Pick<QueryKey<Options<ListInvoiceEligibleOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListInvoiceEligibleOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listInvoiceEligibleOrders({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listInvoiceEligibleOrdersInfiniteQueryKey(options)
});

/**
 * Start batch invoice transmission (email and/or print)
 */
export const startBatchInvoiceTransmissionMutation = (options?: Partial<Options<StartBatchInvoiceTransmissionData>>): UseMutationOptions<StartBatchInvoiceTransmissionResponse, DefaultError, Options<StartBatchInvoiceTransmissionData>> => {
    const mutationOptions: UseMutationOptions<StartBatchInvoiceTransmissionResponse, DefaultError, Options<StartBatchInvoiceTransmissionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startBatchInvoiceTransmission({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Start batch goldenrod production ticket print
 */
export const startBatchGoldenrodPrintMutation = (options?: Partial<Options<StartBatchGoldenrodPrintData>>): UseMutationOptions<StartBatchGoldenrodPrintResponse, StartBatchGoldenrodPrintError, Options<StartBatchGoldenrodPrintData>> => {
    const mutationOptions: UseMutationOptions<StartBatchGoldenrodPrintResponse, StartBatchGoldenrodPrintError, Options<StartBatchGoldenrodPrintData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await startBatchGoldenrodPrint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPrintJobsQueryKey = (options?: Options<ListPrintJobsData>) => createQueryKey('listPrintJobs', options);

/**
 * List print jobs with optional filters
 */
export const listPrintJobsOptions = (options?: Options<ListPrintJobsData>) => queryOptions<ListPrintJobsResponse, DefaultError, ListPrintJobsResponse, ReturnType<typeof listPrintJobsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPrintJobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPrintJobsQueryKey(options)
});

export const listPrintJobsInfiniteQueryKey = (options?: Options<ListPrintJobsData>): QueryKey<Options<ListPrintJobsData>> => createQueryKey('listPrintJobs', options, true);

/**
 * List print jobs with optional filters
 */
export const listPrintJobsInfiniteOptions = (options?: Options<ListPrintJobsData>) => infiniteQueryOptions<ListPrintJobsResponse, DefaultError, InfiniteData<ListPrintJobsResponse>, QueryKey<Options<ListPrintJobsData>>, number | string | Pick<QueryKey<Options<ListPrintJobsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListPrintJobsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listPrintJobs({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPrintJobsInfiniteQueryKey(options)
});

export const getPrintJobQueryKey = (options: Options<GetPrintJobData>) => createQueryKey('getPrintJob', options);

/**
 * Get a specific print job by ID
 */
export const getPrintJobOptions = (options: Options<GetPrintJobData>) => queryOptions<GetPrintJobResponse, GetPrintJobError, GetPrintJobResponse, ReturnType<typeof getPrintJobQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getPrintJob({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getPrintJobQueryKey(options)
});

/**
 * Retry a failed print job
 */
export const retryPrintJobMutation = (options?: Partial<Options<RetryPrintJobData>>): UseMutationOptions<RetryPrintJobResponse, RetryPrintJobError, Options<RetryPrintJobData>> => {
    const mutationOptions: UseMutationOptions<RetryPrintJobResponse, RetryPrintJobError, Options<RetryPrintJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await retryPrintJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listPrintersQueryKey = (options?: Options<ListPrintersData>) => createQueryKey('listPrinters', options);

/**
 * List all configured FolderMill printers
 */
export const listPrintersOptions = (options?: Options<ListPrintersData>) => queryOptions<ListPrintersResponse, DefaultError, ListPrintersResponse, ReturnType<typeof listPrintersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPrinters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPrintersQueryKey(options)
});

/**
 * Create a new FolderMill printer configuration
 */
export const createPrinterMutation = (options?: Partial<Options<CreatePrinterData>>): UseMutationOptions<CreatePrinterResponse, CreatePrinterError, Options<CreatePrinterData>> => {
    const mutationOptions: UseMutationOptions<CreatePrinterResponse, CreatePrinterError, Options<CreatePrinterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createPrinter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a printer configuration
 */
export const deletePrinterMutation = (options?: Partial<Options<DeletePrinterData>>): UseMutationOptions<DeletePrinterResponse, DeletePrinterError, Options<DeletePrinterData>> => {
    const mutationOptions: UseMutationOptions<DeletePrinterResponse, DeletePrinterError, Options<DeletePrinterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deletePrinter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an existing printer configuration
 */
export const updatePrinterMutation = (options?: Partial<Options<UpdatePrinterData>>): UseMutationOptions<UpdatePrinterResponse, UpdatePrinterError, Options<UpdatePrinterData>> => {
    const mutationOptions: UseMutationOptions<UpdatePrinterResponse, UpdatePrinterError, Options<UpdatePrinterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updatePrinter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listAckTemplatesQueryKey = (options?: Options<ListAckTemplatesData>) => createQueryKey('listAckTemplates', options);

/**
 * List all acknowledgment templates
 */
export const listAckTemplatesOptions = (options?: Options<ListAckTemplatesData>) => queryOptions<ListAckTemplatesResponse, DefaultError, ListAckTemplatesResponse, ReturnType<typeof listAckTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listAckTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listAckTemplatesQueryKey(options)
});

/**
 * Create a new acknowledgment template
 */
export const createAckTemplateMutation = (options?: Partial<Options<CreateAckTemplateData>>): UseMutationOptions<CreateAckTemplateResponse, DefaultError, Options<CreateAckTemplateData>> => {
    const mutationOptions: UseMutationOptions<CreateAckTemplateResponse, DefaultError, Options<CreateAckTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createAckTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const selectAckTemplateQueryKey = (options: Options<SelectAckTemplateData>) => createQueryKey('selectAckTemplate', options);

/**
 * Auto-select the best acknowledgment template for an order
 */
export const selectAckTemplateOptions = (options: Options<SelectAckTemplateData>) => queryOptions<SelectAckTemplateResponse, SelectAckTemplateError, SelectAckTemplateResponse, ReturnType<typeof selectAckTemplateQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await selectAckTemplate({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: selectAckTemplateQueryKey(options)
});

/**
 * Delete an acknowledgment template
 */
export const deleteAckTemplateMutation = (options?: Partial<Options<DeleteAckTemplateData>>): UseMutationOptions<DeleteAckTemplateResponse, DeleteAckTemplateError, Options<DeleteAckTemplateData>> => {
    const mutationOptions: UseMutationOptions<DeleteAckTemplateResponse, DeleteAckTemplateError, Options<DeleteAckTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAckTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an existing acknowledgment template
 */
export const updateAckTemplateMutation = (options?: Partial<Options<UpdateAckTemplateData>>): UseMutationOptions<UpdateAckTemplateResponse, UpdateAckTemplateError, Options<UpdateAckTemplateData>> => {
    const mutationOptions: UseMutationOptions<UpdateAckTemplateResponse, UpdateAckTemplateError, Options<UpdateAckTemplateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateAckTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountingListGlCodesQueryKey = (options?: Options<AccountingListGlCodesData>) => createQueryKey('accountingListGlCodes', options);

/**
 * Get all GL codes
 */
export const accountingListGlCodesOptions = (options?: Options<AccountingListGlCodesData>) => queryOptions<AccountingListGlCodesResponse, DefaultError, AccountingListGlCodesResponse, ReturnType<typeof accountingListGlCodesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await accountingListGlCodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: accountingListGlCodesQueryKey(options)
});

/**
 * Create a new GL code
 */
export const accountingCreateGlCodeMutation = (options?: Partial<Options<AccountingCreateGlCodeData>>): UseMutationOptions<AccountingCreateGlCodeResponse, AccountingCreateGlCodeError, Options<AccountingCreateGlCodeData>> => {
    const mutationOptions: UseMutationOptions<AccountingCreateGlCodeResponse, AccountingCreateGlCodeError, Options<AccountingCreateGlCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountingCreateGlCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a GL code
 */
export const accountingDeleteGlCodeMutation = (options?: Partial<Options<AccountingDeleteGlCodeData>>): UseMutationOptions<AccountingDeleteGlCodeResponse, AccountingDeleteGlCodeError, Options<AccountingDeleteGlCodeData>> => {
    const mutationOptions: UseMutationOptions<AccountingDeleteGlCodeResponse, AccountingDeleteGlCodeError, Options<AccountingDeleteGlCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountingDeleteGlCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountingGetGlCodeQueryKey = (options: Options<AccountingGetGlCodeData>) => createQueryKey('accountingGetGlCode', options);

/**
 * Get a GL code by ID
 */
export const accountingGetGlCodeOptions = (options: Options<AccountingGetGlCodeData>) => queryOptions<AccountingGetGlCodeResponse, AccountingGetGlCodeError, AccountingGetGlCodeResponse, ReturnType<typeof accountingGetGlCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await accountingGetGlCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: accountingGetGlCodeQueryKey(options)
});

/**
 * Update an existing GL code
 */
export const accountingUpdateGlCodeMutation = (options?: Partial<Options<AccountingUpdateGlCodeData>>): UseMutationOptions<AccountingUpdateGlCodeResponse, AccountingUpdateGlCodeError, Options<AccountingUpdateGlCodeData>> => {
    const mutationOptions: UseMutationOptions<AccountingUpdateGlCodeResponse, AccountingUpdateGlCodeError, Options<AccountingUpdateGlCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountingUpdateGlCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountingListTermsCodesQueryKey = (options?: Options<AccountingListTermsCodesData>) => createQueryKey('accountingListTermsCodes', options);

/**
 * Get all payment terms codes
 */
export const accountingListTermsCodesOptions = (options?: Options<AccountingListTermsCodesData>) => queryOptions<AccountingListTermsCodesResponse, DefaultError, AccountingListTermsCodesResponse, ReturnType<typeof accountingListTermsCodesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await accountingListTermsCodes({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: accountingListTermsCodesQueryKey(options)
});

/**
 * Create a new payment terms code
 */
export const accountingCreateTermsCodeMutation = (options?: Partial<Options<AccountingCreateTermsCodeData>>): UseMutationOptions<AccountingCreateTermsCodeResponse, AccountingCreateTermsCodeError, Options<AccountingCreateTermsCodeData>> => {
    const mutationOptions: UseMutationOptions<AccountingCreateTermsCodeResponse, AccountingCreateTermsCodeError, Options<AccountingCreateTermsCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountingCreateTermsCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a payment terms code
 */
export const accountingDeleteTermsCodeMutation = (options?: Partial<Options<AccountingDeleteTermsCodeData>>): UseMutationOptions<AccountingDeleteTermsCodeResponse, AccountingDeleteTermsCodeError, Options<AccountingDeleteTermsCodeData>> => {
    const mutationOptions: UseMutationOptions<AccountingDeleteTermsCodeResponse, AccountingDeleteTermsCodeError, Options<AccountingDeleteTermsCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountingDeleteTermsCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountingGetTermsCodeQueryKey = (options: Options<AccountingGetTermsCodeData>) => createQueryKey('accountingGetTermsCode', options);

/**
 * Get a terms code by ID
 */
export const accountingGetTermsCodeOptions = (options: Options<AccountingGetTermsCodeData>) => queryOptions<AccountingGetTermsCodeResponse, AccountingGetTermsCodeError, AccountingGetTermsCodeResponse, ReturnType<typeof accountingGetTermsCodeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await accountingGetTermsCode({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: accountingGetTermsCodeQueryKey(options)
});

/**
 * Update an existing payment terms code
 */
export const accountingUpdateTermsCodeMutation = (options?: Partial<Options<AccountingUpdateTermsCodeData>>): UseMutationOptions<AccountingUpdateTermsCodeResponse, AccountingUpdateTermsCodeError, Options<AccountingUpdateTermsCodeData>> => {
    const mutationOptions: UseMutationOptions<AccountingUpdateTermsCodeResponse, AccountingUpdateTermsCodeError, Options<AccountingUpdateTermsCodeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountingUpdateTermsCode({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountingListPaymentMethodsQueryKey = (options?: Options<AccountingListPaymentMethodsData>) => createQueryKey('accountingListPaymentMethods', options);

/**
 * Get all payment methods, optionally filtered by division
 */
export const accountingListPaymentMethodsOptions = (options?: Options<AccountingListPaymentMethodsData>) => queryOptions<AccountingListPaymentMethodsResponse, DefaultError, AccountingListPaymentMethodsResponse, ReturnType<typeof accountingListPaymentMethodsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await accountingListPaymentMethods({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: accountingListPaymentMethodsQueryKey(options)
});

/**
 * Create a new payment method
 */
export const accountingCreatePaymentMethodMutation = (options?: Partial<Options<AccountingCreatePaymentMethodData>>): UseMutationOptions<AccountingCreatePaymentMethodResponse, AccountingCreatePaymentMethodError, Options<AccountingCreatePaymentMethodData>> => {
    const mutationOptions: UseMutationOptions<AccountingCreatePaymentMethodResponse, AccountingCreatePaymentMethodError, Options<AccountingCreatePaymentMethodData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountingCreatePaymentMethod({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a payment method
 */
export const accountingDeletePaymentMethodMutation = (options?: Partial<Options<AccountingDeletePaymentMethodData>>): UseMutationOptions<AccountingDeletePaymentMethodResponse, AccountingDeletePaymentMethodError, Options<AccountingDeletePaymentMethodData>> => {
    const mutationOptions: UseMutationOptions<AccountingDeletePaymentMethodResponse, AccountingDeletePaymentMethodError, Options<AccountingDeletePaymentMethodData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountingDeletePaymentMethod({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const accountingGetPaymentMethodQueryKey = (options: Options<AccountingGetPaymentMethodData>) => createQueryKey('accountingGetPaymentMethod', options);

/**
 * Get a payment method by ID and division
 */
export const accountingGetPaymentMethodOptions = (options: Options<AccountingGetPaymentMethodData>) => queryOptions<AccountingGetPaymentMethodResponse, AccountingGetPaymentMethodError, AccountingGetPaymentMethodResponse, ReturnType<typeof accountingGetPaymentMethodQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await accountingGetPaymentMethod({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: accountingGetPaymentMethodQueryKey(options)
});

/**
 * Update an existing payment method
 */
export const accountingUpdatePaymentMethodMutation = (options?: Partial<Options<AccountingUpdatePaymentMethodData>>): UseMutationOptions<AccountingUpdatePaymentMethodResponse, AccountingUpdatePaymentMethodError, Options<AccountingUpdatePaymentMethodData>> => {
    const mutationOptions: UseMutationOptions<AccountingUpdatePaymentMethodResponse, AccountingUpdatePaymentMethodError, Options<AccountingUpdatePaymentMethodData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await accountingUpdatePaymentMethod({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTaxInquiryQueryKey = (options?: Options<ListTaxInquiryData>) => createQueryKey('listTaxInquiry', options);

/**
 * List tax calculations with order context, filterable by transaction ID, state, and date range
 */
export const listTaxInquiryOptions = (options?: Options<ListTaxInquiryData>) => queryOptions<ListTaxInquiryResponse, DefaultError, ListTaxInquiryResponse, ReturnType<typeof listTaxInquiryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTaxInquiry({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTaxInquiryQueryKey(options)
});

export const listTaxInquiryInfiniteQueryKey = (options?: Options<ListTaxInquiryData>): QueryKey<Options<ListTaxInquiryData>> => createQueryKey('listTaxInquiry', options, true);

/**
 * List tax calculations with order context, filterable by transaction ID, state, and date range
 */
export const listTaxInquiryInfiniteOptions = (options?: Options<ListTaxInquiryData>) => infiniteQueryOptions<ListTaxInquiryResponse, DefaultError, InfiniteData<ListTaxInquiryResponse>, QueryKey<Options<ListTaxInquiryData>>, number | string | Pick<QueryKey<Options<ListTaxInquiryData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListTaxInquiryData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTaxInquiry({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTaxInquiryInfiniteQueryKey(options)
});

export const listTaxJarLogQueryKey = (options?: Options<ListTaxJarLogData>) => createQueryKey('listTaxJarLog', options);

/**
 * List TaxJar API call logs with tax rate and amount details
 */
export const listTaxJarLogOptions = (options?: Options<ListTaxJarLogData>) => queryOptions<ListTaxJarLogResponse, DefaultError, ListTaxJarLogResponse, ReturnType<typeof listTaxJarLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listTaxJarLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTaxJarLogQueryKey(options)
});

export const listTaxJarLogInfiniteQueryKey = (options?: Options<ListTaxJarLogData>): QueryKey<Options<ListTaxJarLogData>> => createQueryKey('listTaxJarLog', options, true);

/**
 * List TaxJar API call logs with tax rate and amount details
 */
export const listTaxJarLogInfiniteOptions = (options?: Options<ListTaxJarLogData>) => infiniteQueryOptions<ListTaxJarLogResponse, DefaultError, InfiniteData<ListTaxJarLogResponse>, QueryKey<Options<ListTaxJarLogData>>, number | string | Pick<QueryKey<Options<ListTaxJarLogData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListTaxJarLogData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listTaxJarLog({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listTaxJarLogInfiniteQueryKey(options)
});

export const getTaxJarLogQueryKey = (options: Options<GetTaxJarLogData>) => createQueryKey('getTaxJarLog', options);

/**
 * Get a single TaxJar log entry with full jurisdiction-level tax breakdown
 */
export const getTaxJarLogOptions = (options: Options<GetTaxJarLogData>) => queryOptions<GetTaxJarLogResponse, GetTaxJarLogError, GetTaxJarLogResponse, ReturnType<typeof getTaxJarLogQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getTaxJarLog({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getTaxJarLogQueryKey(options)
});

export const listPostEligibleOrdersQueryKey = (options?: Options<ListPostEligibleOrdersData>) => createQueryKey('listPostEligibleOrders', options);

/**
 * List orders eligible for posting (status = INVOICE)
 */
export const listPostEligibleOrdersOptions = (options?: Options<ListPostEligibleOrdersData>) => queryOptions<ListPostEligibleOrdersResponse, DefaultError, ListPostEligibleOrdersResponse, ReturnType<typeof listPostEligibleOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listPostEligibleOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPostEligibleOrdersQueryKey(options)
});

export const listPostEligibleOrdersInfiniteQueryKey = (options?: Options<ListPostEligibleOrdersData>): QueryKey<Options<ListPostEligibleOrdersData>> => createQueryKey('listPostEligibleOrders', options, true);

/**
 * List orders eligible for posting (status = INVOICE)
 */
export const listPostEligibleOrdersInfiniteOptions = (options?: Options<ListPostEligibleOrdersData>) => infiniteQueryOptions<ListPostEligibleOrdersResponse, DefaultError, InfiniteData<ListPostEligibleOrdersResponse>, QueryKey<Options<ListPostEligibleOrdersData>>, number | string | Pick<QueryKey<Options<ListPostEligibleOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListPostEligibleOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listPostEligibleOrders({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listPostEligibleOrdersInfiniteQueryKey(options)
});

/**
 * Post a batch of invoiced orders — commits tax to TaxJar, writes audit logs, sets status to POSTED
 */
export const executeBatchPostMutation = (options?: Partial<Options<ExecuteBatchPostData>>): UseMutationOptions<ExecuteBatchPostResponse, ExecuteBatchPostError, Options<ExecuteBatchPostData>> => {
    const mutationOptions: UseMutationOptions<ExecuteBatchPostResponse, ExecuteBatchPostError, Options<ExecuteBatchPostData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await executeBatchPost({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Post a cash receipt payment to Traverse and write PAY audit log
 */
export const postCashReceiptMutation = (options?: Partial<Options<PostCashReceiptData>>): UseMutationOptions<PostCashReceiptResponse, PostCashReceiptError, Options<PostCashReceiptData>> => {
    const mutationOptions: UseMutationOptions<PostCashReceiptResponse, PostCashReceiptError, Options<PostCashReceiptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCashReceipt({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSalesRegisterOrdersQueryKey = (options?: Options<ListSalesRegisterOrdersData>) => createQueryKey('listSalesRegisterOrders', options);

/**
 * List invoiced orders eligible for the sales register
 */
export const listSalesRegisterOrdersOptions = (options?: Options<ListSalesRegisterOrdersData>) => queryOptions<ListSalesRegisterOrdersResponse, DefaultError, ListSalesRegisterOrdersResponse, ReturnType<typeof listSalesRegisterOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSalesRegisterOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSalesRegisterOrdersQueryKey(options)
});

export const listSalesRegisterOrdersInfiniteQueryKey = (options?: Options<ListSalesRegisterOrdersData>): QueryKey<Options<ListSalesRegisterOrdersData>> => createQueryKey('listSalesRegisterOrders', options, true);

/**
 * List invoiced orders eligible for the sales register
 */
export const listSalesRegisterOrdersInfiniteOptions = (options?: Options<ListSalesRegisterOrdersData>) => infiniteQueryOptions<ListSalesRegisterOrdersResponse, DefaultError, InfiniteData<ListSalesRegisterOrdersResponse>, QueryKey<Options<ListSalesRegisterOrdersData>>, number | string | Pick<QueryKey<Options<ListSalesRegisterOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListSalesRegisterOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listSalesRegisterOrders({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSalesRegisterOrdersInfiniteQueryKey(options)
});

export const getSalesRegisterReportQueryKey = (options?: Options<GetSalesRegisterReportData>) => createQueryKey('getSalesRegisterReport', options);

/**
 * Generate Excel sales register report for invoiced orders in a date range
 */
export const getSalesRegisterReportOptions = (options?: Options<GetSalesRegisterReportData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getSalesRegisterReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSalesRegisterReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSalesRegisterReportQueryKey(options)
});

/**
 * Commit invoiced orders to SALE status — transitions INVOICE → SALE with audit trail
 */
export const commitSalesMutation = (options?: Partial<Options<CommitSalesData>>): UseMutationOptions<CommitSalesResponse2, CommitSalesError, Options<CommitSalesData>> => {
    const mutationOptions: UseMutationOptions<CommitSalesResponse2, CommitSalesError, Options<CommitSalesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await commitSales({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const previewDepositsQueryKey = (options: Options<PreviewDepositsData>) => createQueryKey('previewDeposits', options);

/**
 * Preview undeposited payments grouped by payment method without committing
 */
export const previewDepositsOptions = (options: Options<PreviewDepositsData>) => queryOptions<PreviewDepositsResponse, DefaultError, PreviewDepositsResponse, ReturnType<typeof previewDepositsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await previewDeposits({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: previewDepositsQueryKey(options)
});

/**
 * Process deposit batch — stamps DepNum on payments and writes DEPOSIT audit log entries
 */
export const executeDepositsMutation = (options?: Partial<Options<ExecuteDepositsData>>): UseMutationOptions<ExecuteDepositsResponse, ExecuteDepositsError, Options<ExecuteDepositsData>> => {
    const mutationOptions: UseMutationOptions<ExecuteDepositsResponse, ExecuteDepositsError, Options<ExecuteDepositsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await executeDeposits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSalesTaxReportEntriesQueryKey = (options?: Options<ListSalesTaxReportEntriesData>) => createQueryKey('listSalesTaxReportEntries', options);

/**
 * List TaxJar log entries for the sales tax report
 */
export const listSalesTaxReportEntriesOptions = (options?: Options<ListSalesTaxReportEntriesData>) => queryOptions<ListSalesTaxReportEntriesResponse, DefaultError, ListSalesTaxReportEntriesResponse, ReturnType<typeof listSalesTaxReportEntriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listSalesTaxReportEntries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSalesTaxReportEntriesQueryKey(options)
});

export const listSalesTaxReportEntriesInfiniteQueryKey = (options?: Options<ListSalesTaxReportEntriesData>): QueryKey<Options<ListSalesTaxReportEntriesData>> => createQueryKey('listSalesTaxReportEntries', options, true);

/**
 * List TaxJar log entries for the sales tax report
 */
export const listSalesTaxReportEntriesInfiniteOptions = (options?: Options<ListSalesTaxReportEntriesData>) => infiniteQueryOptions<ListSalesTaxReportEntriesResponse, DefaultError, InfiniteData<ListSalesTaxReportEntriesResponse>, QueryKey<Options<ListSalesTaxReportEntriesData>>, number | string | Pick<QueryKey<Options<ListSalesTaxReportEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListSalesTaxReportEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listSalesTaxReportEntries({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listSalesTaxReportEntriesInfiniteQueryKey(options)
});

export const getSalesTaxReportQueryKey = (options?: Options<GetSalesTaxReportData>) => createQueryKey('getSalesTaxReport', options);

/**
 * Generate Excel sales tax report with detail and summary sheets
 */
export const getSalesTaxReportOptions = (options?: Options<GetSalesTaxReportData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getSalesTaxReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getSalesTaxReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getSalesTaxReportQueryKey(options)
});

export const listDepositReportPaymentsQueryKey = (options?: Options<ListDepositReportPaymentsData>) => createQueryKey('listDepositReportPayments', options);

/**
 * List un-deposited payments (PAY/PAYADJ events without matching DEPOSIT records)
 */
export const listDepositReportPaymentsOptions = (options?: Options<ListDepositReportPaymentsData>) => queryOptions<ListDepositReportPaymentsResponse, DefaultError, ListDepositReportPaymentsResponse, ReturnType<typeof listDepositReportPaymentsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listDepositReportPayments({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDepositReportPaymentsQueryKey(options)
});

export const listDepositReportPaymentsInfiniteQueryKey = (options?: Options<ListDepositReportPaymentsData>): QueryKey<Options<ListDepositReportPaymentsData>> => createQueryKey('listDepositReportPayments', options, true);

/**
 * List un-deposited payments (PAY/PAYADJ events without matching DEPOSIT records)
 */
export const listDepositReportPaymentsInfiniteOptions = (options?: Options<ListDepositReportPaymentsData>) => infiniteQueryOptions<ListDepositReportPaymentsResponse, DefaultError, InfiniteData<ListDepositReportPaymentsResponse>, QueryKey<Options<ListDepositReportPaymentsData>>, number | string | Pick<QueryKey<Options<ListDepositReportPaymentsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListDepositReportPaymentsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listDepositReportPayments({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listDepositReportPaymentsInfiniteQueryKey(options)
});

export const getDepositReportQueryKey = (options?: Options<GetDepositReportData>) => createQueryKey('getDepositReport', options);

/**
 * Generate Excel deposit report with detail and summary sheets
 */
export const getDepositReportOptions = (options?: Options<GetDepositReportData>) => queryOptions<unknown, DefaultError, unknown, ReturnType<typeof getDepositReportQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getDepositReport({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getDepositReportQueryKey(options)
});

/**
 * Commit un-deposited payments — writes DEPOSIT/DEPADJ audit log records
 */
export const commitDepositsMutation = (options?: Partial<Options<CommitDepositsData>>): UseMutationOptions<CommitDepositsResponse2, CommitDepositsError, Options<CommitDepositsData>> => {
    const mutationOptions: UseMutationOptions<CommitDepositsResponse2, CommitDepositsError, Options<CommitDepositsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await commitDeposits({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const globalSearchQueryKey = (options: Options<GlobalSearchData>) => createQueryKey('globalSearch', options);

/**
 * Search orders and customers via Meilisearch typeahead
 */
export const globalSearchOptions = (options: Options<GlobalSearchData>) => queryOptions<GlobalSearchResponse2, DefaultError, GlobalSearchResponse2, ReturnType<typeof globalSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await globalSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: globalSearchQueryKey(options)
});

/**
 * Trigger a full reindex of search data via Hangfire
 */
export const reindexSearchMutation = (options?: Partial<Options<ReindexSearchData>>): UseMutationOptions<ReindexSearchResponse, DefaultError, Options<ReindexSearchData>> => {
    const mutationOptions: UseMutationOptions<ReindexSearchResponse, DefaultError, Options<ReindexSearchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await reindexSearch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listChatSessionsQueryKey = (options?: Options<ListChatSessionsData>) => createQueryKey('listChatSessions', options);

/**
 * List chat sessions for the current user, optionally filtered by entity
 */
export const listChatSessionsOptions = (options?: Options<ListChatSessionsData>) => queryOptions<ListChatSessionsResponse, DefaultError, ListChatSessionsResponse, ReturnType<typeof listChatSessionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listChatSessions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChatSessionsQueryKey(options)
});

export const listChatSessionsInfiniteQueryKey = (options?: Options<ListChatSessionsData>): QueryKey<Options<ListChatSessionsData>> => createQueryKey('listChatSessions', options, true);

/**
 * List chat sessions for the current user, optionally filtered by entity
 */
export const listChatSessionsInfiniteOptions = (options?: Options<ListChatSessionsData>) => infiniteQueryOptions<ListChatSessionsResponse, DefaultError, InfiniteData<ListChatSessionsResponse>, QueryKey<Options<ListChatSessionsData>>, number | string | Pick<QueryKey<Options<ListChatSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListChatSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listChatSessions({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChatSessionsInfiniteQueryKey(options)
});

/**
 * Create a new AI chat session, optionally linked to an entity
 */
export const createChatSessionMutation = (options?: Partial<Options<CreateChatSessionData>>): UseMutationOptions<CreateChatSessionResponse, DefaultError, Options<CreateChatSessionData>> => {
    const mutationOptions: UseMutationOptions<CreateChatSessionResponse, DefaultError, Options<CreateChatSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createChatSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Archive (soft delete) a chat session
 */
export const archiveChatSessionMutation = (options?: Partial<Options<ArchiveChatSessionData>>): UseMutationOptions<ArchiveChatSessionResponse, ArchiveChatSessionError, Options<ArchiveChatSessionData>> => {
    const mutationOptions: UseMutationOptions<ArchiveChatSessionResponse, ArchiveChatSessionError, Options<ArchiveChatSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await archiveChatSession({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getChatSessionQueryKey = (options: Options<GetChatSessionData>) => createQueryKey('getChatSession', options);

/**
 * Get a chat session with its message history
 */
export const getChatSessionOptions = (options: Options<GetChatSessionData>) => queryOptions<GetChatSessionResponse, GetChatSessionError, GetChatSessionResponse, ReturnType<typeof getChatSessionQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getChatSession({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getChatSessionQueryKey(options)
});

/**
 * Update the title of a chat session
 */
export const updateChatSessionTitleMutation = (options?: Partial<Options<UpdateChatSessionTitleData>>): UseMutationOptions<UpdateChatSessionTitleResponse, UpdateChatSessionTitleError, Options<UpdateChatSessionTitleData>> => {
    const mutationOptions: UseMutationOptions<UpdateChatSessionTitleResponse, UpdateChatSessionTitleError, Options<UpdateChatSessionTitleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateChatSessionTitle({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listChatMessagesQueryKey = (options: Options<ListChatMessagesData>) => createQueryKey('listChatMessages', options);

/**
 * List messages in a chat session with pagination
 */
export const listChatMessagesOptions = (options: Options<ListChatMessagesData>) => queryOptions<ListChatMessagesResponse, DefaultError, ListChatMessagesResponse, ReturnType<typeof listChatMessagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listChatMessages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChatMessagesQueryKey(options)
});

export const listChatMessagesInfiniteQueryKey = (options: Options<ListChatMessagesData>): QueryKey<Options<ListChatMessagesData>> => createQueryKey('listChatMessages', options, true);

/**
 * List messages in a chat session with pagination
 */
export const listChatMessagesInfiniteOptions = (options: Options<ListChatMessagesData>) => infiniteQueryOptions<ListChatMessagesResponse, DefaultError, InfiniteData<ListChatMessagesResponse>, QueryKey<Options<ListChatMessagesData>>, number | string | Pick<QueryKey<Options<ListChatMessagesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<ListChatMessagesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listChatMessages({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listChatMessagesInfiniteQueryKey(options)
});

/**
 * Persist a chat message (called by the AI service after streaming)
 */
export const persistChatMessageMutation = (options?: Partial<Options<PersistChatMessageData>>): UseMutationOptions<PersistChatMessageResponse, PersistChatMessageError, Options<PersistChatMessageData>> => {
    const mutationOptions: UseMutationOptions<PersistChatMessageResponse, PersistChatMessageError, Options<PersistChatMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await persistChatMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getApiAiAdminStatsQueryKey = (options?: Options<GetApiAiAdminStatsData>) => createQueryKey('getApiAiAdminStats', options);

export const getApiAiAdminStatsOptions = (options?: Options<GetApiAiAdminStatsData>) => queryOptions<GetApiAiAdminStatsResponse, GetApiAiAdminStatsError, GetApiAiAdminStatsResponse, ReturnType<typeof getApiAiAdminStatsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiAiAdminStats({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAiAdminStatsQueryKey(options)
});

export const getApiAiAdminSessionsQueryKey = (options?: Options<GetApiAiAdminSessionsData>) => createQueryKey('getApiAiAdminSessions', options);

export const getApiAiAdminSessionsOptions = (options?: Options<GetApiAiAdminSessionsData>) => queryOptions<GetApiAiAdminSessionsResponse, DefaultError, GetApiAiAdminSessionsResponse, ReturnType<typeof getApiAiAdminSessionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiAiAdminSessions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAiAdminSessionsQueryKey(options)
});

export const getApiAiAdminSessionsInfiniteQueryKey = (options?: Options<GetApiAiAdminSessionsData>): QueryKey<Options<GetApiAiAdminSessionsData>> => createQueryKey('getApiAiAdminSessions', options, true);

export const getApiAiAdminSessionsInfiniteOptions = (options?: Options<GetApiAiAdminSessionsData>) => infiniteQueryOptions<GetApiAiAdminSessionsResponse, DefaultError, InfiniteData<GetApiAiAdminSessionsResponse>, QueryKey<Options<GetApiAiAdminSessionsData>>, number | string | Pick<QueryKey<Options<GetApiAiAdminSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<GetApiAiAdminSessionsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getApiAiAdminSessions({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAiAdminSessionsInfiniteQueryKey(options)
});

export const getApiAiAdminSessionsByIdMessagesQueryKey = (options: Options<GetApiAiAdminSessionsByIdMessagesData>) => createQueryKey('getApiAiAdminSessionsByIdMessages', options);

export const getApiAiAdminSessionsByIdMessagesOptions = (options: Options<GetApiAiAdminSessionsByIdMessagesData>) => queryOptions<GetApiAiAdminSessionsByIdMessagesResponse, GetApiAiAdminSessionsByIdMessagesError, GetApiAiAdminSessionsByIdMessagesResponse, ReturnType<typeof getApiAiAdminSessionsByIdMessagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getApiAiAdminSessionsByIdMessages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getApiAiAdminSessionsByIdMessagesQueryKey(options)
});

export const listColdFoilPrintersQueryKey = (options?: Options<ListColdFoilPrintersData>) => createQueryKey('listColdFoilPrinters', options);

/**
 * List all configured EPSVT cold foil printers
 */
export const listColdFoilPrintersOptions = (options?: Options<ListColdFoilPrintersData>) => queryOptions<ListColdFoilPrintersResponse, DefaultError, ListColdFoilPrintersResponse, ReturnType<typeof listColdFoilPrintersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await listColdFoilPrinters({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: listColdFoilPrintersQueryKey(options)
});

/**
 * Create a new EPSVT cold foil printer configuration
 */
export const createColdFoilPrinterMutation = (options?: Partial<Options<CreateColdFoilPrinterData>>): UseMutationOptions<CreateColdFoilPrinterResponse, CreateColdFoilPrinterError, Options<CreateColdFoilPrinterData>> => {
    const mutationOptions: UseMutationOptions<CreateColdFoilPrinterResponse, CreateColdFoilPrinterError, Options<CreateColdFoilPrinterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createColdFoilPrinter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete an EPSVT printer configuration
 */
export const deleteColdFoilPrinterMutation = (options?: Partial<Options<DeleteColdFoilPrinterData>>): UseMutationOptions<DeleteColdFoilPrinterResponse, DeleteColdFoilPrinterError, Options<DeleteColdFoilPrinterData>> => {
    const mutationOptions: UseMutationOptions<DeleteColdFoilPrinterResponse, DeleteColdFoilPrinterError, Options<DeleteColdFoilPrinterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteColdFoilPrinter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update an existing EPSVT printer configuration
 */
export const updateColdFoilPrinterMutation = (options?: Partial<Options<UpdateColdFoilPrinterData>>): UseMutationOptions<UpdateColdFoilPrinterResponse, UpdateColdFoilPrinterError, Options<UpdateColdFoilPrinterData>> => {
    const mutationOptions: UseMutationOptions<UpdateColdFoilPrinterResponse, UpdateColdFoilPrinterError, Options<UpdateColdFoilPrinterData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateColdFoilPrinter({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Test connectivity to an EPSVT printer via SOAP
 */
export const testColdFoilPrinterConnectionMutation = (options?: Partial<Options<TestColdFoilPrinterConnectionData>>): UseMutationOptions<TestColdFoilPrinterConnectionResponse, TestColdFoilPrinterConnectionError, Options<TestColdFoilPrinterConnectionData>> => {
    const mutationOptions: UseMutationOptions<TestColdFoilPrinterConnectionResponse, TestColdFoilPrinterConnectionError, Options<TestColdFoilPrinterConnectionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await testColdFoilPrinterConnection({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
